// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================================ */
/* Main Layout Styles */
/* ============================================================================ */

/* Main header styles */
.main-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 30px;
  border-bottom: 1px solid #ccc;
  background-color: white;
  height: 80px; /* Fixed height for header */
}

.logo {
  display: flex;
  align-items: center;
}

.logo img {
  height: 50px;
  width: auto;
}

.main-nav {
  display: flex;
  gap: 30px;
}

.main-nav a {
  color: #333;
  text-decoration: none;
  font-size: 16px;
  font-weight: 500;
  padding: 8px 0;
  position: relative;
  transition: color 0.2s ease;
}

.main-nav a:hover {
  color: #3275c7;
}

.main-nav a.active {
  color: #3275c7;
}

.main-nav a.active:after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: #3275c7;
}




/* Disabled buttons */
.btn:disabled,
.btn.disabled,
button:disabled,
button.disabled {
  background-color: #e2e8f0 !important; /* Light gray background */
  color: #a0aec0 !important; /* Muted text color */
  border-color: #e2e8f0 !important; /* Light border */
  cursor: not-allowed !important; /* Show "not-allowed" cursor on hover */
  opacity: 0.7 !important; /* Reduced opacity */
  box-shadow: none !important; /* Remove any shadow effects */
  pointer-events: none; /* Prevent hover effects */
}

/* For primary buttons with the blue background */
.btn-primary:disabled,
.btn-primary.disabled,
.calculate-button:disabled,
.calculate-button.disabled,
.save-changes-button:disabled,
.save-changes-button.disabled,
.export-map-button:disabled,
.export-map-button.disabled {
  background-color: #a3bfdf !important; /* Lighter version of your blue */
  color: #e5eef8 !important; /* Light text on blue */
  border-color: #a3bfdf !important;
}

/* For secondary/outline buttons */
.btn-outline:disabled,
.btn-outline.disabled,
.criteria-secondary-button:disabled,
.criteria-secondary-button.disabled,
.add-button:disabled,
.add-button.disabled {
  background-color: transparent !important;
  color: #a0aec0 !important;
  border-color: #cbd5e0 !important;
}

/* For hover states (just in case pointer-events doesn't work) */
.btn:disabled:hover,
.btn.disabled:hover,
button:disabled:hover,
button.disabled:hover {
  background-color: #e2e8f0 !important;
  color: #a0aec0 !important;
  border-color: #e2e8f0 !important;
}


body > div[role="presentation"] {
  z-index: 9999 !important;
}


/* New class for dropdown containers */
.select-container-wrapper {
  position: relative;
  margin-bottom: 16px;
  z-index: auto !important;
}

.ReactModal__Content {
  overflow: visible !important; /* Allow dropdowns to overflow */
}

.criteria-content-wrapper .builder-heading {
  display: block;
  position: relative;
  z-index: 1 !important; /* Keep z-index very low so it doesn't interfere with dropdowns */
}


/* Expandable section styles */
.expandable-container {
  width: 100%;
  margin-bottom: 20px;
}

/* Z-index management for proper layering */
.header-expandable {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 0; /* Reduced padding to decrease space between title and line */
  border-bottom: 1px solid #e2e8f0;
  background-color: white;
  z-index: 5; /* Lower z-index so dropdowns can appear above it */
  position: relative;
  margin-left: -25px; /* Extend to full width of parent */
  margin-right: -25px;
  padding-left: 25px;
  padding-right: 25px;
  height: 20px;
  padding-top: 0px;
  padding-bottom: 0px;
  width: calc(100% + 50px); /* Full width including the negative margins */
  z-index: 99999 !important;
}

.expand-toggle-button {
  position: relative;
  background: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #1976d2;
  font-size: 16px;
  height: 30px;
  width: 30px;
  border-radius: 0px;
  transition: background-color 0.2s ease;
  padding-top: 0px;
  padding-bottom: 0px;
  margin: 0px;
  bottom: 10px;
}

.expand-toggle-button:hover {
  background-color: #f0f5ff;
}

.expandable {
  overflow: visible;
  transition: max-height 0.3s ease-in-out, opacity 0.3s ease-in-out, margin-top 0.3s ease-in-out;
  height: auto;
  z-index: 1 !important;
}

.expandable.expanded {
  max-height: 1500px; /* Large enough to contain content */
  opacity: 1;
  margin-top: 0;
  position: relative;
  overflow-y: visible; /* Ensure content is visible even if it overflows */
  padding-bottom: 5px; /* Add padding to ensure Save button is visible */
  padding-top: 5px; /* Add more space after the top line */
}

/* Full-width border for expanded section */
.expandable.expanded::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: -25px; /* Extend beyond container padding */
  right: -25px;
  height: 1px;
  background-color: #e2e8f0;
  margin-bottom: 3px; /* Space between content and border */
}

.expandable.collapsed {
  max-height: 0;
  opacity: 0;
  margin-top: -20px;
  pointer-events: none;
  margin-bottom: 10px; /* Add space after collapsed section */
}

/* Adjust content wrapper position and ensure criteria header visibility */


.expandable.collapsed + .criteria-content-wrapper {
  max-height: 100% !important; /* Adjust based on header height */
  padding-top: 15px; /* Add space for the header */
}


/* Ensure dropdown menu container stays above header */
.css-b62m3t-container {
  position: relative;
  z-index: 20 !important;
}

/* CSS Fix for Builder.tsx - Footer and Scrolling ---------------------------------------------------*/

/* Make the content wrapper scrollable */
.criteria-content-wrapper {
  flex-grow: 1 !important;
  overflow-y: auto !important;
  max-height: calc(100% - 120px) !important; /* Leave space for footer and header */
}

.criteria-content-wrapper::-webkit-scrollbar {
  width: 8px !important;
}

.criteria-content-wrapper::-webkit-scrollbar-track {
  background: #EEF0F2 !important;
}

.criteria-content-wrapper::-webkit-scrollbar-thumb {
  background-color: #CBD5E0 !important;
  border-radius: 4px !important;
}

.contact-page-right .scrollable-content {
  flex-grow: 1 !important;
  overflow-y: auto !important;
  overflow-x: hidden !important;
  padding-right: 5px !important;
  margin-right: -5px !important; /* Pull scrollbar to the edge */
  scrollbar-width: thin !important;
  scrollbar-color: #CBD5E0 #EEF0F2 !important;
}

/* Fix the footer to the bottom of the contact-page-right div */
.builder-fixed-footer {
  flex: 0 0 60px !important; /* Height of 60px, don't grow or shrink */
  width: 100% !important;
  background-color: white !important;
  border-top: 1px solid #e2e8f0 !important;
  z-index: 10 !important;
  display: flex !important;
  align-items: center !important;
  margin-left: -25px !important; /* Counter the parent padding */
  padding: 0 25px !important; /* Add padding inside */
  width: calc(100% + 50px) !important; /* Full width including margins */
}

.explorer-fixed-footer {
  flex: 0 0 60px !important; /* Height of 60px, don't grow or shrink */
  width: calc(100% + 50px) !important;
  background-color: white !important;
  border-top: 1px solid #e2e8f0 !important;
  z-index: 10 !important;
  display: flex !important;
  align-items: center !important;
  margin-left: -25px !important; /* Counter the parent padding */
  padding: 0 25px !important; /* Add padding inside */
  height: 100px; /* Full width including margins */
}

/* Style for the buttons in the footer */
.builder-fixed-footer .button-group {
  display: flex !important;
  gap: 5px !important;
  justify-content: space-between !important;
  width: 100% !important;
}

/* Style for the buttons in the footer */
.explorer-fixed-footer .button-group {
  display: flex !important;
  gap: 20px !important;
  justify-content: space-between !important;
  width: 100% !important;
}


/* Scrollbar styles for webkit browsers */
.scrollable-content::-webkit-scrollbar,
.criteria-content-wrapper::-webkit-scrollbar {
  width: 8px !important;
  background: #EEF0F2 !important;
}

.scrollable-content::-webkit-scrollbar-thumb,
.criteria-content-wrapper::-webkit-scrollbar-thumb {
  background-color: #CBD5E0 !important;
  border-radius: 4px !important;
}


/* Criteria Inputs Styling ------------------------------------------------------------------------------------*/

.criteria-content-wrapper .builder-heading {
  display: block;
  position: relative;
  z-index: 5;
}

.expandable.collapsed + .criteria-content-wrapper {
  max-height: calc(100% - 60px) !important;
  padding-top: 15px; /* Add space for the header */
}

.save-changes-button {
  background-color: #1976d2 !important;
  color: white !important;
  border: none !important;
  border-radius: 4px !important;
  padding: 8px 16px !important;
  cursor: pointer !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  height: 38px !important;
}

.save-changes-button:hover {
  background-color: #164677 !important;
}

.criteria-secondary-button {
  background-color: white !important;
  color: #1976d2 !important;
  border: 1px solid #1976d2 !important;
  border-radius: 4px !important;
  padding: 1px 8px !important;
  cursor: pointer !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  height: 38px !important;
}

.criteria-secondary-button:hover {
  background-color: #f0f5ff !important;
}


.criteria-input-container {
  margin-bottom: 8px;
  position: static !important;
  z-index: auto !important;
}

.criteria-input {
  width: 100%;
  padding: 8px 12px;
  font-size: 14px;
  color: #333;
  border: 1px solid #e2e8f0;
  border-radius: 4px;
  background-color: white;
  height: 38px;
  box-sizing: border-box;
}

.criteria-input:focus {
  border-color: #1976d2;
  outline: none;
  box-shadow: 0 0 0 1px rgba(26, 83, 135, 0.2);
}

.criteria-input-clear {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: #718096;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  height: 16px;
  width: 16px;
  z-index: 2;
}

.criteria-input-group {
  display: flex;
  gap: 8px;
  width: 100%;
}

.criteria-input-group .criteria-input {
  flex: 1 1;
}

/* Range inputs */
.criteria-range-container {
  display: flex;
  gap: 8px;
  width: 100%;
}

.criteria-range-input {
  flex: 1 1;
  position: relative;
}

/* Custom dropdown styling */
.criteria-dropdown {
  position: relative;
  width: 100%;
}

.criteria-dropdown-select {
  width: 100%;
  padding: 8px 12px;
  font-size: 14px;
  color: #333;
  border: 1px solid #e2e8f0;
  border-radius: 4px;
  background-color: white;
  appearance: none;
  height: 38px;
  box-sizing: border-box;
}

.criteria-dropdown-select:focus {
  border-color: #1976d2;
  outline: none;
}

.criteria-dropdown::after {
  content: "▼";
  font-size: 10px;
  color: #718096;
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
}

/* MUI Select overrides */
.criteria-mui-select {
  width: 100%;
  height: 38px;
  font-size: 14px;
}

.criteria-mui-select .MuiOutlinedInput-root {
  height: 38px;
  border-radius: 4px;
}

.criteria-mui-select .MuiOutlinedInput-notchedOutline {
  border-color: #e2e8f0;
}

.criteria-mui-select .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {
  border-color: #cbd5e1;
}

.criteria-mui-select .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
  border-color: #1976d2;
}

.criteria-mui-select .MuiSelect-select {
  padding: 8px 12px;
  height: 38px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
}

/* React-select overrides */
.criteria-react-select {
  width: 100%;
}

.criteria-react-select .css-13cymwt-control,
.criteria-react-select .css-t3ipsp-control {
  min-height: 38px;
  border-color: #e2e8f0;
  box-shadow: none;
}

.criteria-react-select .css-t3ipsp-control:hover {
  border-color: #cbd5e1;
}

.criteria-react-select .css-t3ipsp-control:focus-within {
  border-color: #1976d2;
  box-shadow: 0 0 0 1px rgba(26, 83, 135, 0.2);
}

/* Chip styling for multi-select */
.criteria-chip {
  display: inline-flex;
  align-items: center;
  background: #e2e8f0;
  border-radius: 16px;
  padding: 2px 8px;
  margin: 2px;
  font-size: 12px;
}

.criteria-chip-delete {
  margin-left: 4px;
  cursor: pointer;
  font-size: 14px;
  line-height: 1;
}

/* Export Map button styling */
.export-map-button {
  background-color: #1976d2;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 16px;
}

.export-map-button:hover {
  background-color: #164677;
}

/* Add to your App.css */
.criteria-buttons-layout {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  margin-top: 15px;
}

.top-buttons-row {
  display: flex;
  gap: 10px;
}

.middle-button-row {
  margin: 10px 0;
}

.criteria-buttons-row {
  display: flex;
  gap: 10px;
  margin-top: 15px;
}

.export-button-container {
  margin-top: -52px; /* Adjust this value as needed to align with other buttons */
  display: flex;
  justify-content: center;
}

.builder-section-title {
  font-size: 16px;
  font-weight: 600;
  color: #1976d2; /* Blue text color */
  margin-bottom: 3px;
  margin-top: 0px;
  display: block;
}

.builder-input-container {
  position: static !important;
  z-index: auto !important;
}

.builder-clear-button {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: #718096;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  height: 16px;
  width: 16px;
  z-index: 2;
}

.builder-action-button {
  background-color: #1976d2; /* Blue button */
  color: white;
  border: none;
  border-radius: 4px;
  padding: 8px 16px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  margin-right: 10px;
  margin-top: 10px;
}

.builder-criteria-button {
  background-color: white;
  color: #1976d2; /* Blue text */
  border: 1px solid #1976d2; 
  border-radius: 4px;
  padding: 8px 16px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  margin-top: 10px;
}

.builder-heading {
  font-size: 20px;
  font-weight: bold;
  color: #1976d2;
  margin-bottom: 5px;
  position: relative; 
}

/* Override styles for DynamicSelector */
.filter-section-title {
  font-size: 16px;
  font-weight: 600;
  color: #1976d2 !important;
  margin-top: 10px;
  display: block;
}

/* Override styles for MUI components in Builder */
.contact-page-right .MuiInputBase-root {
  border-radius: 4px;
}

.contact-page-right .MuiOutlinedInput-notchedOutline {
  border-color: #e2e8f0;
}

.contact-page-right .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {
  border-color: #cbd5e1;
}

.contact-page-right .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
  border-color: #1976d2;
}

/* Customize the comparison selector in CriteriaSelector */
.comparison-selector {
  background-color: white;
  border: 1px solid #e2e8f0;
  border-radius: 4px;
  padding: 8px 16px;
}

.comparison-selector:hover {
  border-color: #cbd5e1;
}

/* Customize the value input in CriteriaSelector */
.criteria-value-input {
  width: 100%;
  padding: 8px;
  border: 1px solid #e2e8f0;
  border-radius: 4px;
}

.criteria-value-input:focus {
  border-color: #1976d2;
  outline: none;
}



.add-button {
  background-color: white !important;
  color: #1976d2 !important;
  border: 1px solid #1976d2 !important;
  border-radius: 4px !important;
  padding: 10px 8px !important;
  cursor: pointer !important;
  font-size: 14px !important;
  font-weight: 500 !important;
}

.add-button:hover {
  background-color: #f0f5ff !important;
}

.calculate-button {
  background-color: #1976d2 !important;
  color: white !important;
  border: none !important;
  border-radius: 4px !important;
  padding: 0px 8px !important;
  cursor: pointer !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  height: 38px !important;
}

.calculate-button:hover {
  background-color: #164677 !important;
}

/* Custom styling for parameter selectors */
.p-4.border.rounded-md {
  padding: 0 !important;
  border: none !important;
  border-radius: 0 !important;
  margin-bottom: 16px !important;
}

.p-4.border.rounded-md p.font-semibold.mb-2 {
  font-size: 16px !important;
  font-weight: 600 !important;
  color: #1976d2 !important;
  margin-bottom: 8px !important;
}

/* Override for the criteria editor */
.criteria-row {
  border: 1px solid #e2e8f0 !important;
  border-radius: 4px !important;
}

/* ------------------------------------------------------------------ */

.upload-buttons-container {
  display: flex;
  justify-content: center; /* Centers the buttons */
  gap: 10px; /* Space between buttons */
  margin-top: 10px;
}

.custom-dataset-section {
  margin-top: 15px;
  margin-bottom: 15px;
  padding-top: 10px;
  border-top: 1px solid #eaeaea;
}

.custom-dataset-title {
  font-size: 16px;
  font-weight: 600;
  color: #1976d2;
  margin-bottom: 12px;
}

.upload-data-section {
  padding-bottom: 100px !important; /* Large padding at bottom */
  margin-bottom: 60px !important;
}

.export-container {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-bottom: 15px;
}

.export-container button,
.custom-dataset-section button {
  background-color: #1976d2;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.export-container button:hover,
.custom-dataset-section button:hover {
  background-color:  #132a4d; /* Slightly darker on hover */
}

.overlay-selector {
  margin-top: 15px;
}

html, body, #root {
  overflow: hidden;
  padding: 0;
  height: 100%;
  width: 100%;
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.MuiTab-root {
  font-size: 12px;
  font-weight: 500;
  text-transform: none;
  color: #333;
  padding: 4px 8px !important;
  border-radius: 3px !important; 
  transition: all 0.2s ease;
  min-height: 30px !important;
  max-height: 30px !important;
}

.MuiTab-root.Mui-selected {
  background-color: #1a365d;
  color: white !important;
  font-weight: 600;
  border: 1px solid transparent;
}


/* ------------------------------------------- */


/* Reset some default browser styles */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

/* Global Variables */
:root {
  --light-gray: #dae5ef;
  --blue: #2d4778;
  --green: #c1ff81;
  --gray: #9aa7b2;
  --light-blue: #aed8ff;
  --white: #ffffff;

  --primary-color: var(--blue);
  --secondary-color: var(--light-blue);
  --text-color: var(--white);
  --hover-color: var(--light-gray);
  --active-color: var(--light-gray);
  --transition-speed: 0.3s;
}

/* ============================================================================ */
/* Main Layout Styles */
/* ============================================================================ */

.logo {
  display: flex;
  align-items: center;
}

.logo img {
  height: 50px;
  width: auto;
}

.main-nav {
  display: flex;
  gap: 30px;
}

.main-nav a {
  color: #333;
  text-decoration: none;
  font-size: 16px;
  font-weight: 500;
  padding: 8px 0;
  position: relative;
  transition: color 0.2s ease;
}

.main-nav a:hover {
  color: #3275c7;
}

.main-nav a.active {
  color: #3275c7;
}

.main-nav a.active:after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: #3275c7;
}

/* Main content wrapper - takes full remaining height */
.content-wrapper {
  background-color: #EEF0F2;
  min-height: calc(100vh);
  display: flex;
  flex-direction: column;
}

/* Tools navigation container */
.tools-container {
  background-color: white;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  flex: 1 1;
}

.tools-nav ul {
  display: flex;
  background-color: white; /* Changed from #f2f4f6 to white */
  border-radius: 25px;
  padding: 5px;
  list-style: none;
  margin: 0;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
}

.tools-nav li {
  margin: 0;
  padding: 0;
}

.tools-nav a {
  display: block;
  padding: 8px 20px;
  color: #506580;
  text-decoration: none;
  font-size: 14px;
  font-weight: 500;
  border-radius: 20px;
  transition: all 0.2s ease;
}

.tools-nav a:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

.tools-nav a.active {
  background-color: #DEEBFF;
  color: #3275c7;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* Tool content area - takes full remaining height */
.tool-content {
  flex: 1 1;
  padding: 0;
  overflow: auto;
}

/* ============================================================================ */
/* Tabs */
/* ============================================================================ */

/* Style the Tabs container */
.MuiTabs-root {
  gap: 4px;
  min-height: 40px;
  background-color: white;
}

/* Style each Tab */
.MuiTab-root {
  min-height: 40px;
  text-transform: none;
  color: #718096;
  padding: 0 16px;
  font-size: 14px;
  opacity: 1;
  border: 1px solid #E2E8F0;
  margin-left: 0;
}

.MuiTab-root:first-child {
  margin-left: 0;
}

.MuiTab-root:hover {
  background-color: rgba(26, 54, 93, 0.1);
}

.MuiTab-root.Mui-selected {
  color: white;
  background-color: #1976d2;
  border: 1px solid black; /* Border matching the background color */
}

/* Style for disabled Tabs */
.MuiTab-root.Mui-disabled {
  background-color: var(--gray) !important;
  color: var(--light-gray);
  opacity: 0.7;
  border-radius: 0 !important;
}

/* Remove the default indicator (underline) */
.MuiTabs-indicator {
  display: none;
}

/* ============================================================================ */
/* Page Layouts - Explorer, Builder, Comparator */
/* ============================================================================ */

/* Container for all pages */
.contact-page-container {
  height: 100vh; /* Ensure full height minus header */
  overflow: hidden;
  background-color: #EEF0F2;
  display: grid;
  grid-template-columns: 3fr 1fr;
  gap: 20px;
  padding: 0 !important;
}

/* Left section for Tabs and MapImage */
.contact-page-left {
  height: 100%; /* Increase the height by adding pixels */
  display: flex;
  flex-direction: column;
  padding: 0 !important;
  overflow: hidden;
  padding: 0 !important; /* Remove padding */
}

/* Right section for Selectors, Parameters etc */
.contact-page-right {
  /* Essential structure */
  display: flex !important;
  flex-direction: column !important;
  height: 100% !important;
  max-height: 100%!important;
  overflow: hidden !important; /* Prevent container from scrolling */
  position: relative !important;
  
  /* Remove conflicting padding */
  padding-bottom: 0 !important; /* Remove the 130px bottom padding */
  
  /* Keep other existing styles */
  transform: translateZ(0);
  padding-left: 25px !important;
  padding-right: 5px !important; 
  padding-top: 20px !important;
  box-sizing: border-box !important;
  margin-right: 0 !important;
  border-radius: 0 !important;
  width: 100% !important;
  right: 0 !important;
  background: #ffffff !important;
  
  /* Fix scrollbar appearance */
  scrollbar-width: thin;
  scrollbar-color: #CBD5E0 #EEF0F2;
  z-index: auto !important;
}

.contact-page-right::-webkit-scrollbar {
  width: 8px; /* Thin scrollbar */
}

.contact-page-right::-webkit-scrollbar-track {
  background: #EEF0F2; /* Light background for the track */
}

.contact-page-right::-webkit-scrollbar-thumb {
  background-color: #CBD5E0; /* Grayish color for the scrollbar thumb */
  border-radius: 4px; /* Rounded corners */
}

.contact-page-right::-webkit-scrollbar-thumb:hover {
  background-color: #A0AEC0; /* Slightly darker on hover */
}

.scrollable-content {
  flex: 1 1 auto !important;
  overflow-y: auto !important;
  padding-right: 5px !important;
  margin-right: -5px !important; /* Pull scrollbar to edge */
}

.contact-page-map-container {
  height: 100%; /* Change to full height */
  margin: 0 !important;
  padding: 0 !important;
  border: none !important;
  background-color: transparent !important;
  box-shadow: none !important;
}

.leaflet-container {
  width: 100%;
  height: 100%;
  padding: 0px !important;
  margin: 0px !important;
}

.map-resolution-container {
  display: flex;
  align-items: center;
  background-color: white;
  border-bottom: 1px solid #e0e4e8;
  padding: 0 20px;
}

.map-resolution-title {
  font-size: 14px;
  font-weight: 600;
  color: #2d3748;
  margin-right: 20px;
  white-space: nowrap;
}

/* ============================================================================ */
/* Comparator-specific styles */
/* ============================================================================ */

/* Adjust grid for comparator page */
.contact-page-container.comparator {
  grid-template-columns: 5fr 1fr;
}

/* Updated to use flex-wrap and new structure */
.contact-page-maps {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin-top: 20px;
  gap: 20px; /* Gap between rows and columns */
  transition: width 0.3s ease-in-out;
}

.map-column {
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* Top row map (first map) */
.map-column:first-child {
  width: 50%; /* Same width as other maps */
  margin-bottom: 20px; /* Space between rows */
  margin-left: auto;
  margin-right: auto; /* Center the top map */
}

/* Bottom row maps (second and third maps) */
.map-column:not(:first-child) {
  width: calc(50% - 10px); /* Each takes approximately half width minus gap */
}

.map-column h3 {
  margin-bottom: 10px;
  text-align: center;
}

.comparator-page-map-container {
  width: 100%;
  height: 400px; /* Same height for all maps */
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #ddd;
  border-radius: 4px;
  background-color: var(--light-gray);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  max-width: 100%;
}

/* ============================================================================ */
/* Map and Overlay Styles */
/* ============================================================================ */

.map-container {
  height: 100%;
  width: 100%;
}

/* Overlay buttons */
.overlay-buttons {
  position: absolute; /* Ensures it's above the map */
  top: 10px; /* Position from the top */
  right: 10px; /* Position from the right */
  z-index: 1000; /* Make sure it's above the map */
  display: flex;
  gap: 5px;
}

.overlay-button {
  background-color: white;
  border: 1px solid #ccc;
  padding: 8px;
  border-radius: 5px;
  cursor: pointer;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.2);
}

.overlay-button.active {
  background-color: #007bff;
  color: white;
}

/* Button Group */
.btn-group {
  display: inline-flex;
  border-radius: 4px;
  overflow: hidden;
  margin-top: 10px;
}

.btn-group .btn {
  border-radius: 0;
  margin: 0;
}

.btn-group .btn:not(:last-child) {
  border-right: 1px solid var(--gray);
}

.btn-group .btn:first-child {
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
}

.btn-group .btn:last-child {
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
}

/* Toggle Button for OverlaySelector */
.btn-toggle {
  background-color: var(--light-gray);
  color: var(--primary-color);
  font-weight: bold;
  width: 130px;
}

.btn-toggle:hover {
  background-color: var(--secondary-color);
  color: var(--primary-color);
}

.btn-toggle.selected {
  background-color: var(--primary-color);
  color: var(--text-color);
}

/* ============================================================================ */
/* Legend Styles */
/* ============================================================================ */

/* Legend container */
.overlay-legend {
  position: absolute;
  bottom: 20px;
  left: 20px;
  background: rgba(255, 255, 255, 0.8);
  padding: 10px;
  border-radius: 8px;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.2);
  font-size: 14px;
  z-index: 1000; /* Ensure it's above the map */
  pointer-events: auto; /* Ensure interaction is enabled */
}

/* Each legend section */
.legend-section {
  margin-bottom: 10px;
}

/* Title of each legend */
.legend-title {
  font-weight: bold;
  margin-bottom: 5px;
}

/* Legend item */
.legend-item {
  display: flex;
  align-items: center;
  margin-bottom: 4px;
}

/* Colored square for legend */
.legend-color {
  width: 16px;
  height: 16px;
  margin-right: 5px;
  border-radius: 3px;
  display: inline-block;
}

/* Standalone legend container */
.legend-container {
  padding: 10px;
  background: white;
  border: 1px solid #ccc;
  width: 400px;
  text-align: left;
  border-radius: 5px;
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.2);
  margin-top: 10px;
  margin-bottom: 10px;
  display: flex;
}

.legend-gradient {
  margin-top: 5px;
  width: 400px;
  height: 20px;
  display: flex;
}

.legend-values {
  display: flex;
  justify-content: space-between;
  width: 400px;
  font-size: 12px;
}

.legend-list {
  list-style: none;
  padding: 10;
  margin: 10;
  display: flex;
}

.legend-color-box {
  width: 40px;
  height: 20px;
  display: inline-block;
  margin-right: 5px;
  border: 1px solid black;
}

/* ============================================================================ */
/* Feature Table Styles */
/* ============================================================================ */

.feature-table-container {
  margin-top: 10px;
  padding: 10px;
  background: white;
  border: 1px solid #ccc;
  border-radius: 5px;
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.2);
}

.feature-table {
  width: 100%;
  border-collapse: collapse;
}

.feature-table th,
.feature-table td {
  border: 1px solid #ccc;
  padding: 5px;
  text-align: left;
}

/* ============================================================================ */
/* Dynamic Selectors and Form Controls */
/* ============================================================================ */

/* Label style for the text above the slider */
.slider-label {
  font-size: 1rem; /* Adjust the font size */
  font-weight: bold; /* Make the text bold */
  text-align: center; /* Center the text */
  margin-bottom: 10px; /* Add some space between the label and the slider */
  color: #333; /* Set the text color */
}

/* Range slider styles */
.range-slider-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 8px;
}

.sliders-section {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.slider-wrapper {
  display: flex;
  align-items: center;
  margin-bottom: 5px;
}

.slider-label {
  width: 40px;
  font-size: 14px;
}

.slider-label-right {
  text-align: right;
}

.slider-input-wrapper {
  flex-grow: 1;
  margin: 0 10px;
}

.slider-input {
  width: 100%;
}

/* ============================================================================ */
/* Criteria Selector Styles */
/* ============================================================================ */

.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

/* Expression Box */
.expression-box {
  border: 2px solid black;
  padding: 16px;
  min-width: 250px;
  text-align: center;
  font-family: monospace;
  white-space: pre-line; /* Keeps line breaks */
}

/* Placeholder text */
.placeholder {
  color: gray;
}



/* Calculate Button */
.calculate-button {
  background: limegreen;
  border: 2px solid black;
  padding: 8px 16px;
  cursor: pointer;
  font-weight: bold;
  display: flex;
  align-items: center;
}

/* Trash Button */
.trash-button {
  color: red;
  font-size: 20px;
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
}

/* Trash Button hover */
.trash-button:hover {
  color: red;
  font-size: 20px;
  background: lightgray;
  border: none;
}

.parameter-addition-button {
  display: flex;
  justify-content: center;
  margin-bottom: 0;
}

.parameter-addition-button-save {
  display: flex;
  justify-content: right;
  margin-bottom: 0;
  padding-right: 10px;
}

.add-button {
  padding: 8px 16px;
  background-color: limegreen;
  color: white;
  border-radius: 4px;
}

.criteria-selector {
  padding: 20px;
  font-family: Arial, sans-serif;
  background-color: #f9f9f9;
  border: 1px solid #ddd;
  border-radius: 8px;
  max-width: 400px;
  margin: 20px auto;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.criteria-selector input[type="text"] {
  width: 100%;
  padding: 8px;
  margin-bottom: 10px;
  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 4px;
  outline: none;
  transition: border-color 0.3s ease;
}

.criteria-selector input[type="text"]:focus {
  border-color: #007bff;
}

.operator-buttons,
.logical-operators {
  display: flex;
  gap: 10px;
  margin-bottom: 10px;
}

.operator-buttons button.base,
.logical-operators button.base {
  flex: 1 1;
  padding: 10px;
  font-size: 16px;
  cursor: pointer;
  background-color: #3b34c8;
  border: 1px solid #ccc;
  border-radius: 4px;
  transition: background-color 0.2s ease, border-color 0.2s ease;
}

.operator-buttons button,
.logical-operators button {
  flex: 1 1;
  padding: 10px;
  font-size: 16px;
  cursor: pointer;
  background-color: #3b34c8;
  border: 1px solid #ccc;
  border-radius: 4px;
  transition: background-color 0.2s ease, border-color 0.2s ease;
}

.operator-buttons button:hover,
.logical-operators button:hover {
  background-color: #007bff; 
}

.operator-buttons button.active,
.logical-operators button.active {
  background-color: #007bff;
  color: white;
  border-color: #007bff;
}

.logical-operators .trash-button {
  background-color: #f8d7da;
  color: #721c24;
}

.logical-operators .trash-button:hover {
  background-color: #f5c6cb;
}

.number-input {
  width: 100%;
  padding: 8px;
  margin-bottom: 10px;
  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 4px;
  outline: none;
}

.number-input:focus {
  border-color: #007bff;
}

.criteria-rows {
  border-top: 1px solid #ddd;
  padding-top: 10px;
}

.criteria-row {
  padding: 8px 0;
  font-size: 16px;
  color: #333;
}

/* ============================================================================ */
/* Drag & Drop Component Styles */
/* ============================================================================ */

.drag-drop-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  width: 90%;
}

.bucket {
  border: 2px dashed #ccc;
  padding: 5px;
  width: 95%;  /* Ensure it takes full width */
  min-height: 50px;
  display: flex;
  flex-wrap: wrap;  /* Allows wrapping if items overflow */
  justify-content: flex-start;  /* Aligns items to the left */
  align-items: center; /* Ensures vertical centering */
  background-color: #f9f9f9;
  gap: 10px; /* Adds spacing between items */
  height: auto;
}

.fruit-item {
  padding: 5px 10px;
  background-color: #ffcc80;
  border: 1px solid #5549d8;
  border-radius: 5px;
  cursor: grab;
  font-size: 12px;
  display: inline-flex;  /* Ensures items are displayed in a row */
  align-items: center; /* Centers text inside items */
  white-space: nowrap; /* Prevents text from breaking into multiple lines */
}

.drop-areas {
  min-height: 50px;
  display: flex;
  width: 100%;
  gap: 10px;
  padding: 5px;
  min-height: 50px;
  text-align: center;
  background-color: #e3f2fd;
  flex: 1 1; 
  flex-direction: row;
}

.drop-area {
  min-height: 50px;
  border: 2px solid #888;
  padding: 5px 10px;
  max-width: 300px;
  width: 100%;
  border-radius: 5px;
  cursor: grab;
  font-size: 12px;
}

/* ============================================================================ */
/* Import & Modal Styles */
/* ============================================================================ */

.import-button {
  background-color: #1a365d;
  color: white;
  padding: 8px 16px;
  border-radius: 4px;
  border: none;
  cursor: pointer;
  font-size: 14px !important;
  font-weight: 500 !important;
  height: 36px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  width: 100vw;
  height: 100vh;
}

.modal-content {
  background-color: white;
  border-radius: 8px;
  padding: 24px;
  width: 450px;
  position: relative;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 1001;
}

.close-button {
  position: absolute;
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  background: transparent !important;
  color: #666;
  font-size: 16px;
  top: 10px;
  right: 10px;
  z-index: 10002; /* Higher than modal content */
}

.modal-title {
  font-weight: 600;
  color: #1a365d;
  font-size: 18px;
  margin-bottom: 20px;
}



.form-group {
  margin-bottom: 20px;
}

.form-label {
  font-weight: 500;
  color: #1a365d;
  margin-bottom: 8px;
  display: block;
}

.form-input {
  width: 100%;
  padding: 8px;
  border: 1px solid #e2e8f0;
  border-radius: 4px;
}

.button-group {
  margin-top: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-bottom: 5px;
  flex-wrap: wrap;
}

.type-button {
  padding: 6px 12px !important;
  margin-right: 8px !important;
  display: inline-block !important;
  font-size: 14px !important;
  border: 1px solid #e2e8f0 !important;
  border-radius: 4px !important;
  background-color: white !important;
}

.color-selector {
  background-color: #1a365d !important;
  color: white !important;
  border-color: #1a365d !important;
 }

.type-button.active {
  background-color: #1a365d;
  color: white;
  border-color: #1a365d;
}

.type-button.inactive {
  background-color: white;
  color: #4a5568;
}

.color-preview {
  flex-grow: 1;
  height: 24px;
  border-radius: 4px;
  border: 1px solid #e2e8f0;
}

.scheme-select .MuiSelect-select,
.form-group .MuiOutlinedInput-root {
 display: flex !important;
 align-items: center !important;
 justify-content: space-between !important;
}

.form-group .MuiSelect-select .color-text {
  flex: 0 0 auto !important;
  margin-right: 10px !important;
 }

 .color-preview-container {
  flex: 1 1 !important;
  margin-left: 10px !important;
}


 .form-group .MuiSelect-select .color-preview {
  display: inline-block !important;
  width: 60% !important;
  height: 24px !important;
  margin-left: auto !important;
 }
 
 /* For standard select if not using MUI */
.form-group select,
.form-input {
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
}

.form-group .MuiSelect-select,
.form-group .MuiOutlinedInput-root {
  width: 100% !important;
  z-index: auto !important;
}
 
 /* Direct approach if needed */
 .color-scheme-option {
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
  width: 100% !important;
 }

.MuiSelect-select {
  padding: 8px 14px !important;
}

.MuiSelect-select,
.css-1dimb5e-singleValue,
.css-1s2u09g-control,
.css-13cymwt-control,
.form-input,
.color-select-option {
 display: flex !important;
 flex-direction: row !important;
 align-items: center !important;
 justify-content: space-between !important;
 white-space: nowrap !important;
}

.MuiMenuItem-root,
.css-10wo9uf-option,
.dropdown-option {
 display: flex !important;
 align-items: center !important;
 justify-content: space-between !important;
 width: 100% !important;
}

/* Make sure text and gradient are on same line */
.scheme-name {
  display: inline-block !important;
  margin-right: 10px !important;
  width: auto !important;
  white-space: nowrap !important;
 }

 .color-gradient {
  display: inline-block !important;
  width: 150px !important;
  height: 24px !important;
  margin-left: auto !important;
  vertical-align: middle !important;
 }

.MuiMenuItem-root {
  padding: 8px 14px !important;
}

.modal-footer {
  display: flex !important;
  justify-content: flex-end !important;
  gap: 10px !important;
  margin-top: 20px !important;
}

.cancel-button {
  padding: 8px 16px !important;
  border: 1px solid #e2e8f0 !important;
  border-radius: 4px !important;
  background-color: white !important;
  cursor: pointer !important;
  color: #4a5568 !important;
}

/* File upload input styling */
.file-input {
  border: 1px solid #e2e8f0 !important;
  border-radius: 4px !important;
  padding: 8px !important;
  width: 100% !important;
  display: block !important;
}

.save-button {
  background-color: #1a365d !important;
  color: white !important;
  border: none !important;
 }

.scheme-select {
  display: flex !important;
  flex-direction: row !important;
  align-items: center !important;
}

.scheme-select .MuiSelect-select {
  padding: 8px 14px !important;
  background-color: white;
}

.scheme-select .MuiOutlinedInput-notchedOutline {
  border-color: #e2e8f0 !important;
}

.scheme-select:hover .MuiOutlinedInput-notchedOutline {
  border-color: #cbd5e1 !important;
}

/* ============================================================================ */
/* User-Defined Metric & Custom Components */
/* ============================================================================ */

.modal-overlay-sc {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;  /* Full viewport width */
  height: 100vh;  /* Full viewport height */
  background-color: rgba(0, 0, 0, 0.5); /* Semi-transparent background */
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: auto; /* Prevents background scrolling */
  flex-direction: column;
  z-index: 1001;
}

.modal-title-sc {
  color: #1a365d;
  margin-bottom: 2px;
}

.modal-content-sc {
  width: 90%; /* Adjust width */
  max-width: 90%; /* Limit max width */
  max-height: 80vh; /* Prevent the modal from exceeding screen height */
  background: white;
  padding: 10px;
  overflow-y: false; /* Enables vertical scrolling */
  display: flex;
  flex-direction: row;
}

.modal-content-second {
  width: 90%; /* Adjust width */
  max-width: 90%; /* Limit max width */
  max-height: 80vh; /* Prevent the modal from exceeding screen height */
  background: white;
  padding: 10px;
  overflow-y: false; /* Enables vertical scrolling */
  display: flex;
  flex-direction: column;
}

.selector-container-sc {
  width: 50%;
  display: flex;
  flex-wrap: wrap;
  flex: 1 1;
  margin-bottom: 10px;
  gap: 10px; /* Spacing between components */
  background: #ffffff; /* White background */
  padding: 20px;
  border-radius: 12px;
  border: 1px;
  border-color: black;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Clean shadow */
  align-items: flex-start; /* Align items to the top */
}

.parameter-container-sc {
  width: 50%;
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 10px;
  gap: 10px; /* Spacing between components */
  background: #ffffff; /* White background */
  padding: 20px;
  border-radius: 12px;
  border: 1px;
  border-color: black;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Clean shadow */
  align-items: flex-start; /* Align items to the top */
  flex-direction: column;
}

.user-dataset-selector-sc {
  flex: 1 1;
  margin-right: 10px;
}

.map-selector-sc {
  flex: 1 1;
}

.column-selector-sc {
  flex: 1 1;
  width: 100%;
}

.parameters-container {
  width: 100%; /* Ensures it takes full width */
}

.parameter-selected-sc {
  flex: 1 1;
  width: 100%;
}

.equation-container {
  align-items: center;
  width: 90%; /* Adjust width */
  max-width: 90%; /* Limit max width */
  max-height: 80vh; /* Prevent the modal from exceeding screen height */
  background: white;
  padding: 10px;
  display: flex;
  flex-direction: row;
}

.equation-selected-sc {
  padding: 10px;
}

.classification-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 20px;
  margin-top: 20px;
}

.classification-item {
  flex: 1 1;
  background-color: #f8f9fa;
  padding: 15px;
  border-radius: 8px;
  border: 1px solid #ddd;
  transition: box-shadow 0.2s ease-in-out;
}

.classification-item:hover {
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
}

.category-bar {
  display: flex;
  margin-top: 10px;
  height: 20px;
}

.category {
  text-align: center;
  font-size: 12px;
  font-weight: bold;
  color: white;
  padding: 3px;
}

.high {
  background-color: red;
}

.medium {
  background-color: orange;
}

.low {
  background-color: green;
}

.reverse-btn {
  margin-top: 10px;
  background-color: #007bff;
  color: white;
  border: none;
  padding: 5px 10px;
  cursor: pointer;
  border-radius: 5px;
}

.reverse-btn:hover {
  background-color: #0056b3;
}

.equation-histogram-group {
  width: 200px; /* Adjust width */
  max-width: 90%; /* Limit max width */
  max-height: 400px; /* Prevent the modal from exceeding screen height */
  background: white;
  padding: 10px;
  border-radius: 12px;
  border: 1px;
  border-color: black;
  overflow-y: false; /* Enables vertical scrolling */
  display: flex;
  flex-direction: row;
}

.equation-histogram-tile {
  width: 200px; 
  max-width: 90%; 
  max-height: 80vh; 
  background: white;
  padding: 10px;
  border-radius: 12px;
  border: 1px;
  border-color: black;
  overflow-y: false; /* Enables vertical scrolling */
  display: flex;
  flex-direction: row;
}

/* Parent container: Displays histogram groups horizontally */
.histogram-container {
  display: flex;
  justify-content: space-between; /* Space between the groups */
  align-items: flex-start; /* Align the groups at the top */
  gap: 20px; /* Space between each group */
  padding: 20px;
}

/* Each histogram group (stacked vertically) */
.histogram-group {
  flex: 1 1; /* Equal width for each group */
  display: flex;
  flex-direction: column;
  align-items: center;
  border: 2px solid #ddd;
  padding: 15px;
  border-radius: 10px;
  background-color: #f9f9f9;
  min-width: 250px;
  width: 90%;
}

.histogram-chart {
  position: relative;
  margin-top: 10px;
  width: 100%; /* Use full width of parent */
  max-width: 600px; /* Prevent it from being too wide */
  min-width: 300px;
  height: 80%; /* Make it taller */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.process-btn {
  position: relative;
  margin-top: 10px;
  width: 150px; /* Use full width of parent */
  align-items: center;
  justify-content: center;
}

/* Input fields */
.histogram-group input {
  width: 80%;
  padding: 8px;
  margin: 10px 0;
  border-radius: 5px;
  border: 1px solid #ccc;
  text-align: center;
}

/* Button styling */
.histogram-group button {
  background-color: #007bff;
  color: white;
  border: none;
  padding: 8px 12px;
  border-radius: 5px;
  cursor: pointer;
  margin-bottom: 10px;
}

.histogram-group button:hover {
  background-color: #0056b3;
}

/* Ensure charts don't overflow */
.histogram-group canvas {
  max-width: 100%;
}

/* Parameters container for UserDefinedMetricParameters */
.parameters-container {
  margin-top: 2px;
  padding: 10px;
  width: 100%;
}

.parameter-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.parameter-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #f8f9fa;
  padding: 5px 10px;
  margin: 10px 0;
  border-radius: 5px;
  border: 1px solid #ddd;
  transition: background-color 0.2s ease-in-out;
}

.parameter-row:hover {
  background-color: #e9ecef;
}

.parameter-details {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.parameter-name {
  font-weight: bold;
  color: #333;
}

.parameter-info {
  color: #555;
}

.delete-button {
  color: red;
  cursor: pointer;
}

/* Export styling */
.export {
  display: flex;
  flex-direction: column;
  gap: 20px; /* Spacing between components */
  border-radius: 12px;
}

/* Function Builder */
.function-builder {
  padding: 20px;
  font-family: Arial, sans-serif;
  background-color: #f9f9f9;
  border: 1px solid #ddd;
  border-radius: 8px;
  max-width: 400px;
  margin: 20px auto;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.function-builder input[type="text"] {
  width: 100%;
  padding: 8px;
  margin-bottom: 10px;
  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
  outline: none;
  transition: border-color 0.3s ease;
}

.function-builder input[type="text"]:focus {
  border-color: #007bff;
}

.scrollable-list {
  border: 1px solid #ccc;
  max-height: 200px;
  overflow-y: auto;
  border-radius: 4px;
  margin-bottom: 10px;
  background-color: #fff;
  box-shadow: inset 0 2px 3px rgba(0, 0, 0, 0.1);
}

.scrollable-list div {
  padding: 10px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.scrollable-list div:hover {
  background-color: #f0f0f0;
}

.scrollable-list div.selected {
  background-color: #007bff;
  color: white;
}

/* ============================================================================ */
/* Intro Page Styles */
/* ============================================================================ */

/* Wave Container */
.wave-container {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 150px; /* Ensure enough height */
  overflow: hidden; /* Prevent extra scrolling */
}

/* Waves */
.wave {
  position: absolute;
  width: 100%;
  bottom: 0; /* Align to bottom */
}

.back-wave {
  opacity: 0.6;
  z-index: 3; /* Behind */
}

.front-wave {
  opacity: 0.9;
  z-index: 2; /* In front of back wave */
}

.middle-wave {
  opacity: 0.75;
  z-index: 1; /* Middle wave */
}

/* ============================================================================ */
/* Button Styles */
/* ============================================================================ */

/* Button Base Styles */
.btn {
  display: inline-block;
  font-family: "Arial", sans-serif;
  font-weight: 600;
  line-height: 1.5;
  text-align: center;
  text-decoration: none;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  padding: 10px 20px;
  border-radius: 6px;
  transition: all 0.3s ease;
  border: 2px solid transparent;
}

/* Primary Button */
.btn-primary {
  background-color: #1976d2;
  color: var(--text-color);
}

.btn-primary:hover,
.btn-primary:focus {
  background-color: var(--blue);
  opacity: 0.9;
}

/* Secondary Button */
.btn-secondary {
  background-color: var(--light-blue);
  color: var(--primary-color);
}

.btn-secondary:hover,
.btn-secondary:focus {
  background-color: var(--light-gray);
}

/* Outline Button */
.btn-outline {
  background-color: transparent;
  border-color: var(--primary-color);
  color: var(--primary-color);
}

.btn-outline:hover,
.btn-outline:focus {
  background-color: var(--primary-color);
  color: var(--white);
}

/* Ghost Button */
.btn-ghost {
  background-color: transparent;
  color: var(--primary-color);
}

.btn-ghost:hover,
.btn-ghost:focus {
  background-color: var(--light-gray);
}

/* Disabled Button */
.btn:disabled,
.btn.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Button Sizes */
.btn-sm {
  font-size: 12px;
  padding: 6px 12px;
}

.btn-lg {
  font-size: 16px;
  padding: 12px 24px;
}

button {
  margin-bottom: 2px; /* Space before the histogram */
  margin-top: 2px;
}

/* ============================================================================ */
/* Modern Selector Styles - Based on the provided image */
/* ============================================================================ */

/* Filter section styles */
.filter-section {
  margin-bottom: 5px;
}

.filter-section-title {
  font-size: 14px;
  font-weight: 600;
  color: #333;
  margin-bottom: 1px;
  display: block;
}

/* Selected dataset item */
.dataset-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 4px;
  padding: 8px 12px;
  margin-bottom: 8px;
  width: 100%;
}

.dataset-item-text {
  font-size: 14px;
  color: #333;
}

.dataset-item-actions {
  display: flex;
  align-items: center;
}

.remove-btn {
  background: none;
  border: none;
  color: #999;
  cursor: pointer;
  font-size: 14px;
  padding: 0 4px;
}

.toggle-btn {
  background: none;
  border: none;
  color: #999;
  cursor: pointer;
  font-size: 14px;
  padding: 0 4px;
}

/* Radio Button Styles */
.radio-group {
  display: flex;
  gap: 8px;
  width: 100%;
}

.radio-option {
  flex: 1 1;
  position: relative;
}

.radio-option input[type="radio"] {
  position: absolute;
  opacity: 0;
  height: 0;
  width: 0;
}

.radio-option label {
  display: flex;
  align-items: center;
  padding: 4px;
  background-color: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  color: #333;
  width: 100%;
  position: relative;
  transition: all 0.2s ease;
}

/* Custom radio circle */
.radio-option label::before {
  content: "";
  display: inline-block;
  width: 16px;
  height: 16px;
  margin-right: 8px;
  border: 1px solid #ccc;
  border-radius: 50%;
  background-color: white;
}

/* Selected radio styling */
.radio-option input[type="radio"]:checked + label::before {
  border-color: #2563eb; /* Blue border */
  background-color: white;
  box-shadow: inset 0 0 0 4px #2563eb; /* Blue center dot */
}

/* Dropdown selector */
.selector-dropdown {
  position: relative;
  width: 100%;
  margin-bottom: 12px;
}

.selector-dropdown select {
  appearance: none;
  width: 100%;
  padding: 8px 12px;
  font-size: 14px;
  border: 1px solid #e2e8f0;
  border-radius: 4px;
  background-color: white;
  cursor: pointer;
  color: #71717a; /* Placeholder color */
}

/* Arrow for dropdown */
.selector-dropdown::after {
  content: "▼";
  font-size: 12px;
  color: #999;
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
}

/* Grid layout for SSP options */
.grid-radio-group {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 3px;
  margin-bottom: 0px;
}

.grid-radio-option {
  position: relative;
}

.grid-radio-option label {
  display: flex;
  align-items: center;
  padding: 8px;
  background-color: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  color: #333;
  width: 100%;
}

/* Custom radio circle for grid layout */
.grid-radio-option label::before {
  content: "";
  display: inline-block;
  width: 16px;
  height: 16px;
  margin-right: 6px;
  border: 1px solid #ccc;
  border-radius: 50%;
  background-color: white;
}

/* Selected grid radio styling */
.grid-radio-option input[type="radio"]:checked + label::before {
  border-color: #2563eb; /* Blue border */
  background-color: white;
  box-shadow: inset 0 0 0 4px #2563eb; /* Blue center dot */
}

/* Hide default radio for grid options */
.grid-radio-option input[type="radio"] {
  position: absolute;
  opacity: 0;
  height: 0;
  width: 0;
}

.year-section-title {
  align-items: center;
  margin-bottom: 10px;
  font-size: 14px;
  font-weight: 600;
  color: #333;

  margin-left: 0 !important;
  display: inline-block !important;
  padding-bottom: 8px !important;
}

.year-range {
  margin-left: 5px;
  font-weight: normal;
  color: #666;
}

/* Checkbox style for Log Scale - independent from year selector */
.log-scale-wrapper {
  display: flex;
  align-items: center;
  margin-top: 8px;
  margin-bottom: 12px;
}

.log-scale-checkbox {
  height: 16px;
  width: 16px;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  margin-right: 8px;
  cursor: pointer;
}

.log-scale-checkbox:checked {
  background-color: #2563eb;
  border-color: #2563eb;
}

.log-scale-label {
  font-size: 14px;
  color: #1976d2;
  cursor: pointer;
}



/* Override MUI Slider styles to match the design */
.MuiSlider-root {
  color: #1a365d !important; /* Match button color */
  height: 4px !important;
  padding: 13px 0 !important;

  margin-left: 10px !important; /* Important - shift slider right */
  width: calc(100% - 20px) !important;
  box-sizing: border-box !important;
}

.MuiSlider-root .MuiSlider-thumb {
  transform: translate(-50%, -50%)  !important;
  margin-top: 0  !important;
  margin-left: 0  !important;
}

.MuiSlider-thumb[style*="left: 0%"] {
  transform: translate(0%, -50%) !important; /* Don't shift left when at 0% */
 }

.MuiSlider-thumb {
  width: 14px !important;
  height: 14px !important;
  background-color: white !important;
  border: 2px solid #1a365d !important;
  margin-top: -5px !important; /* Vertical alignment fix */
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2) !important;
  transform: translate(-50%, -50%) !important;
  cursor: pointer;
}

/* Fix for Firefox */
@-moz-document url-prefix() {
  .MuiSlider-thumb {
    margin-top: -6px !important;
  }
}

.MuiSlider-thumb:hover {
  box-shadow: 0 0 0 8px rgba(26, 54, 93, 0.1) !important;
}

.MuiSlider-thumb:hover .MuiSlider-valueLabel {
  opacity: 1 !important;
 }


.MuiSlider-valueLabel {
  transition: opacity 0.2s ease;
  opacity: 0 !important;
  background-color: #1a365d !important;
  color: white !important;
  font-size: 12px !important;
  padding: 4px 6px !important;
  border-radius: 4px !important;
  transform: translateY(-20px) !important;
}

.MuiSlider-track {
  height: 4px !important;
  background-color: #2563eb !important;
  border: none !important;
}

.MuiSlider-rail {
  height: 4px !important;
  background-color: #e2e8f0 !important;
  border-radius: 2px !important;
}

.MuiSlider-mark {
  height: 8px !important;
  width: 1px !important;
  background-color: #e2e8f0 !important;
  margin-top: -2px !important;
}

.MuiSlider-markActive {
  background-color: #2563eb !important;
}

.MuiSlider-markLabel {
  color: #666 !important;
  font-size: 12px !important;
}

/* Tailwind-like classes for Log Scale checkbox from Explorer */
.flex.items-center.space-x-2 {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
  margin-bottom: 16px;
}

.h-4.w-4.rounded.border-gray-300.text-blue-600.focus\\:ring-blue-500 {
  height: 16px;
  width: 16px;
  border-radius: 4px;
  border: 1px solid #d1d5db;
  color: #2563eb;
  cursor: pointer;
}

.h-4.w-4.rounded.border-gray-300.text-blue-600.focus\\:ring-blue-500:checked {
  background-color: #2563eb;
  border-color: #2563eb;
}

.text-sm.font-medium.text-gray-700 {
  font-size: 14px;
  font-weight: 500;
  color: #4b5563;
  cursor: pointer;
}

/* Styles for DynamicSelector */
.p-4.border.rounded-md {
  padding: 12px;
  border: none;
  border-radius: 4px;
  margin-bottom: 16px;
}

.p-4.border.rounded-md p.font-semibold.mb-2 {
  font-size: 14px;
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;
}

.p-4.border.rounded-md .space-y-2 {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

/* Modify the DynamicSelector Radio type */
.p-4.border.rounded-md .flex.items-center.gap-2.cursor-pointer {
  display: flex;
  align-items: center;
  position: relative;
  padding-left: 24px;
  cursor: pointer;
}

.p-4.border.rounded-md input[type="radio"] {
  position: absolute;
  opacity: 0;
  height: 0;
  width: 0;
}

.p-4.border.rounded-md .flex.items-center.gap-2.cursor-pointer::before {
  content: "";
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 16px;
  height: 16px;
  border: 1px solid #ccc;
  border-radius: 50%;
  background-color: white;
}

.p-4.border.rounded-md input[type="radio"]:checked + .flex.items-center.gap-2.cursor-pointer::before {
  border-color: #2563eb;
  background-color: white;
  box-shadow: inset 0 0 0 4px #2563eb;
}

/* Modify the DynamicSelector Dropdown type */
.p-4.border.rounded-md select.p-2.border.rounded-md.w-full {
  appearance: none;
  width: 100%;
  padding: 8px 12px;
  font-size: 14px;
  border: 1px solid #e2e8f0;
  border-radius: 4px;
  background-color: white;
  cursor: pointer;
  color: #71717a;
}

/* Enhance Select component */
.searchable-selector {
  margin-bottom: 8px;
}

/* React-select customization */
.css-13cymwt-control {
  border-color: #e2e8f0 !important;
  box-shadow: none !important;
  border-radius: 4px !important;
  height: 38px !important;
}

.css-t3ipsp-control {
  border-color: #d1d5db !important;
  box-shadow: none !important;
  height: 38px !important;
}

.css-1dimb5e-singleValue, 
.css-qbdosj-Input, 
.css-1jqq78o-placeholder {
  color: #333 !important;
}

.css-166bipr-Input {
  color: #333 !important;
}

/* Fix color scheme preview inside select dropdown */
.MuiSelect-select .MuiBox-root,
.css-w2ww2f,
.form-group > div,
.select-container {
  display: flex !important;
  flex-direction: row !important;
  align-items: center !important;
  width: 100% !important;
}

.color-option {
  display: flex !important;
  align-items: center !important;
  width: 100% !important;
}

/* This ensures the dropdown menu will appear above other content */
.select-container-wrapper .css-26l3qy-menu,
.select-container-wrapper .css-1nmdiq5-menu {
  z-index: 9999 !important;
}

.css-26l3qy-menu,
.css-1nmdiq5-menu {
  z-index: 9999 !important;
}

body .css-26l3qy-menu,
body .css-1nmdiq5-menu {
  position: absolute !important;
  top: auto !important; 
  margin-top: 0 !important;
  z-index: 9999 !important;
}

body > div[role="presentation"] {
  z-index: 9999 !important;
}

/* Ensure dropdown opens above all other elements */
.css-b62m3t-container {
  position: relative  !important;
}

/* Force menu to portal to body to avoid stacking context issues */
.select-dropdown-portal {
  position: relative !important;
}

.builder-input-container {
  position: static !important;
  z-index: auto !important;
}

/* Intro Page Styles ------------------------------------------------------------------------ */

/* Intro Page with Larger Elements */
.intro-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  min-height: 100vh;
  width: 100%;
  background-color: #f9f9f9;
  position: relative;
  overflow: hidden;
  padding: 0;
  margin: 0;
}

/* Main content with side-by-side layout - positioned higher on page */
.intro-content {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 92%;
  max-width: 1400px; /* Increased from 1200px */
  z-index: 5;
  gap: 60px; /* Increased from 40px */
  margin-top: 12vh;
}

/* Logo container on the left */
.intro-logo-container {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex: 1 1;
}

.intro-logo {
  max-width: 450px; /* Increased from 380px */
  width: 100%;
  height: auto;
}

/* Cards container on the right */
.intro-cards-container {
  display: flex;
  flex-direction: column;
  gap: 30px; /* Increased from 20px */
  flex: 1 1;
}

/* Row of cards */
.cards-row {
  display: flex;
  gap: 30px; /* Increased from 20px */
  width: 100%;
}

/* Individual card styling */
.intro-card {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: white;
  border-radius: 10px; /* Increased from 8px */
  padding: 50px 25px; /* Increased from 40px 20px */
  text-decoration: none;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05); /* Slightly stronger shadow */
  min-height: 150px; /* Increased from 120px */
  text-align: center;
  transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
}

.intro-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
}

.card-icon {
  margin-bottom: 25px; /* Increased from 20px */
}

.card-icon svg {
  width: 40px; /* Increased from 30px */
  height: 40px; /* Increased from 30px */
  stroke: #1976d2;
  stroke-width: 2;
}

.card-text {
  color: #1976d2;
  font-size: 18px; /* Increased from 16px */
  font-weight: 500;
}

/* Wave container */
.wave-container {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 250px;
  z-index: 1;
  overflow: hidden;
}

.wave {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
}

.wave-top {
  bottom: 45px;
  opacity: 0.7;
}

.wave-middle {
  bottom: 25px;
  opacity: 0.8;
}

.wave-bottom {
  bottom: -5px; /* This extends slightly below the viewport to eliminate white space */
  opacity: 0.9;
}

/* Responsive adjustments */
@media (max-width: 1200px) {
  .intro-content {
    width: 95%;
    gap: 40px;
  }
  
  .intro-logo {
    max-width: 400px;
  }
  
  .intro-card {
    padding: 45px 20px;
  }
}

@media (max-width: 992px) {
  .intro-content {
    flex-direction: column;
    gap: 40px;
    margin-top: 8vh;
  }
  
  .intro-logo-container {
    justify-content: center;
  }
  
  .intro-logo {
    max-width: 350px;
  }
  
  .cards-row {
    gap: 20px;
  }
}

@media (max-width: 600px) {
  .intro-content {
    margin-top: 5vh;
  }
  
  .cards-row {
    flex-direction: column;
    gap: 15px;
  }
  
  .intro-card {
    padding: 35px 20px;
    min-height: 130px;
  }
  
  .card-icon svg {
    width: 35px;
    height: 35px;
  }
  
  .card-text {
    font-size: 16px;
  }
}

/* Navigation Bar Styles - Add these to your App.css ------------------------------------------------------------------------*/

/* Tools navigation container */
.tools-nav {
  background-color: #EEF0F2;
  width: 100%;
  padding: 10px;
  display: flex;
  justify-content: space-between;
}

/* Left, center and right sections of the navbar */
.nav-left, .nav-right {
  flex: 1 1;
}

.nav-center {
  flex: 4 1;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

/* Back to Home link styles */
.back-to-home {
  position: absolute;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  color: #1976d2;
  font-size: 14px;
  font-weight: 500;
  padding: 8px 16px;
  border-radius: 20px;
  background-color: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  transition: all 0.2s ease;
  margin-top: 5px;
}

.back-to-home:hover {
  background-color: #f0f5ff;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}

.back-icon {
  display: inline-flex;
  vertical-align: middle;
  margin-right: 6px;
}

.back-text {
  display: inline-flex;
  vertical-align: middle;
}

/* Main navigation links */
.main-links {
  display: flex;
  background-color: white;
  border-radius: 25px;
  padding: 5px;
  list-style: none;
  margin: 0;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
}

.main-links a {
  display: block;
  padding: 8px 20px;
  color: #506580;
  text-decoration: none;
  font-size: 14px;
  font-weight: 500;
  border-radius: 20px;
  transition: all 0.2s ease;
}

.main-links a:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

.main-links a.active {
  background-color: #DEEBFF;
  color: #3275c7;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* Responsive adjustments */
@media (max-width: 992px) {
  .nav-center {
    flex: 6 1;
  }
  
  .back-to-home {
    padding: 6px 12px;
    font-size: 13px;
  }
  
  .main-links a {
    padding: 6px 15px;
  }
}

@media (max-width: 768px) {
  .tools-nav {
    flex-direction: column;
    padding: 10px;
  }
  
  .nav-center {
    flex-direction: column;
    gap: 10px;
    width: 100%;
    margin-top: 10px;
  }
  
  .back-to-home {
    position: static;
    margin-bottom: 10px;
    width: 100%;
    justify-content: center;
  }
  
  .main-links {
    width: 100%;
    justify-content: center;
  }
}


/* Define Custom Metric Dialog Styles ------------------------------------------------------------------------------------------------------------------------------------------------------*/
/* Custom Metric Dialog Styling */
.modal-content {
  border-radius: 3px;
  overflow: visible;
}

.modal-title {
  padding: 16px 20px;
  font-size: 18px;
  font-weight: 400;
  border-bottom: 1px solid #e0e0e0;
}

.modal-content-second {
  padding: 15px;
}

/* Tab styling for UserDefinedMetric */
.metric-tabs {
  min-height: 40px;
  border-bottom: 1px solid #f0f0f0;
}

.metric-tab {
  text-transform: none;
  font-size: 14px;
  font-weight: 400;
  min-height: 40px;
  padding: 8px 16px;
  color: #555;
}

.metric-tab.active {
  color: #1976d2;
  font-weight: 500;
}

.metric-tab-indicator {
  background-color: #1976d2;
  height: 2px;
}

/* Info alert box */
.metric-info-alert {
  background-color: #e3f2fd;
  padding: 12px 15px;
  border-radius: 4px;
  margin-bottom: 20px;
  font-size: 14px;
  color: #0d47a1;
}

/* Graph container styling */
.metric-graph-container {
  height: 180px;
  width: 100%;
  margin-bottom: 15px;
}

.metric-graph-title {
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  color: #555;
  margin-bottom: 10px;
}

/* Classification slider */
.classification-slider {
  margin-top: 10px;
}

.classification-slider-label {
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 5px;
}

.slider-values {
  font-size: 12px;
  color: #555;
}

/* Parameters section */
.parameters-container {
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  padding: 15px;
  background-color: #f9f9f9;
  margin-bottom: 15px;
}

.parameter-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid #eee;
}

.parameter-row:last-child {
  border-bottom: none;
}

.parameter-name {
  font-weight: 500;
  margin-right: 4px;
}

.parameter-info {
  margin: 0 8px;
  color: #666;
}

/* Buttons */
.process-data-btn {
  background-color: #1976d2;
  color: white;
  text-transform: none;
  box-shadow: none;
  font-size: 14px;
  height: 36px;
  border-radius: 4px;
  border: none;
  padding: 0 16px;
  cursor: pointer;
}

.process-data-btn:hover {
  background-color: #1565c0;
}

.reverse-categories-btn {
  margin-top: 10px;
  background-color: #1976d2;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 6px 12px;
  font-size: 12px;
  cursor: pointer;
}

.reverse-categories-btn:hover {
  background-color: #1565c0;
}

/* Category bar coloring */
.category-high {
  background-color: #e53935;
}

.category-medium {
  background-color: #fb8c00;
}

.category-low {
  background-color: #43a047;
}

/* Error message */
.equation-error {
  padding: 8px 12px;
  background-color: #ffebee;
  border-radius: 4px;
  color: #c62828;
  margin-bottom: 12px;
  font-size: 14px;
}

/* Input fields */
.metric-text-field {
  font-size: 14px;
  height: 36px;
}

/* Dialog actions */
.metric-dialog-actions {
  padding: 12px 20px;
  border-top: 1px solid #e0e0e0;
  display: flex;
  justify-content: space-between;
}


/* Classification Slider Styling --------------------------------------------------------*/
/* Fixed position labels below slider */
.category-label-container {
  display: flex;
  justify-content: space-between;
  width: 100%;
  position: relative;
  margin-top: 15px;
  height: 20px;
}

.category-label {
  position: relative;
  font-size: 13px;
  color: #333;
}

.category-label::before {
  content: '';
  position: absolute;
  top: -10px;
  left: 50%;
  transform: translateX(-50%);
  height: 10px;
  width: 1px;
  background-color: #999;
}

/* Hide the colored category sections but keep functionality */

/* Style the slider itself */

.MuiSlider-thumb {
  height: 16px !important;
  width: 16px !important;
  background-color: #fff !important;
  border: 2px solid #2196f3 !important;
  margin-top: -6px !important;
}

.MuiSlider-track {
  height: 4px !important;
  background-color: #2196f3 !important;
}

.MuiSlider-rail {
  height: 4px !important;
  background-color: #e0e0e0 !important;
}

/* Classification Slider Styling */
.slider-viz-container {
  position: relative;
  margin-top: 10px;
  height: 30px;
  width: 100%;
}

.slider-marker {
  position: absolute;
  top: 0;
  width: 1px;
  height: 10px;
  background-color: #666;
}

.slider-label {
  position: absolute;
  top: 15px;
  transform: translateX(-50%);
  font-size: 13px;
  color: #333;
}

.blue-button {
  margin-top: 10px;
  background-color: #1976d2;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 6px 12px;
  font-size: 13px;
  cursor: pointer;
}

/* SLIDER ---------------------------------*/

/* Classification labels */
.classification-label {
  position: absolute;
  top: 0;
  height: 30px;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: visible; /* Allow text to overflow */
  white-space: nowrap; /* Keep text on one line */
}

/* Style for narrow columns - adjust text display */
.narrow-column {
  overflow: visible; /* Make sure text can overflow the column */
  justify-content: flex-start; /* Align text to left */
  padding-left: 2px; /* Small padding from the line */
  z-index: 1; /* Ensure text appears above other elements */
}


.MuiSlider-thumb {
  background-color: #0d6efd !important;
  border: 2px solid #0d6efd !important;
}

.MuiSlider-track {
  background-color: #0d6efd !important;
}

/* Button styling */
.blue-button {
  margin-top: 15px;
  background-color: #1976d2;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 6px 12px;
  font-size: 13px;
  cursor: pointer;
}

/* Dynamic classification container */
.dynamic-classification-container {
  position: relative;
  width: 100%;
  height: 30px;
  margin-top: 0px;
}

/* Container with labels below - increase height */
.dynamic-classification-container.has-labels-below {
  height: 20px;
}

/* Vertical marker lines */
.marker-line {
  position: absolute;
  top: 20%;
  width: 1px;
  height: 70%;
  background-color: #1976d2 ;
  transform: translateX(-0.5px); /* Center the marker */
  padding-left: 1px;
  padding-right: 1px;
}

/* Container for labels displayed below */
.labels-below-container {
  position: relative;
  width: 100%;
  height: 20px;
  margin-top: 5px;
}

/* Individual label displayed below */
.label-below {
  position: absolute;
  transform: translateX(-50%); /* Center horizontally */
  font-size: 14px;
  white-space: nowrap;
  margin-top: 5px;
}

/* Slider styling overrides */

.MuiSlider-thumb {
  background-color: #1976d2 !important;
  border: 2px solid #1976d2 !important;
}

.MuiSlider-track {
  background-color: #1976d2 !important;
}

/* Button styling */
.blue-button {
  margin-top: 15px;
  background-color: #1976d2;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 6px 12px;
  font-size: 13px;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,iFAAiF;AACjF,uBAAuB;AACvB,iFAAiF;;AAEjF,uBAAuB;AACvB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;EAC7B,uBAAuB;EACvB,YAAY,EAAE,4BAA4B;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,WAAW;EACX,yBAAyB;AAC3B;;;;;AAKA,qBAAqB;AACrB;;;;EAIE,oCAAoC,EAAE,0BAA0B;EAChE,yBAAyB,EAAE,qBAAqB;EAChD,gCAAgC,EAAE,iBAAiB;EACnD,8BAA8B,EAAE,uCAAuC;EACvE,uBAAuB,EAAE,oBAAoB;EAC7C,2BAA2B,EAAE,8BAA8B;EAC3D,oBAAoB,EAAE,0BAA0B;AAClD;;AAEA,iDAAiD;AACjD;;;;;;;;EAQE,oCAAoC,EAAE,iCAAiC;EACvE,yBAAyB,EAAE,uBAAuB;EAClD,gCAAgC;AAClC;;AAEA,kCAAkC;AAClC;;;;;;EAME,wCAAwC;EACxC,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA,gEAAgE;AAChE;;;;EAIE,oCAAoC;EACpC,yBAAyB;EACzB,gCAAgC;AAClC;;;AAGA;EACE,wBAAwB;AAC1B;;;AAGA,sCAAsC;AACtC;EACE,kBAAkB;EAClB,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,4BAA4B,EAAE,gCAAgC;AAChE;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,qBAAqB,EAAE,iEAAiE;AAC1F;;;AAGA,8BAA8B;AAC9B;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA,2CAA2C;AAC3C;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc,EAAE,6DAA6D;EAC7E,gCAAgC;EAChC,uBAAuB;EACvB,UAAU,EAAE,mDAAmD;EAC/D,kBAAkB;EAClB,kBAAkB,EAAE,mCAAmC;EACvD,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,wBAAwB,EAAE,8CAA8C;EACxE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,sCAAsC;EACtC,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,8FAA8F;EAC9F,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,kBAAkB,EAAE,oCAAoC;EACxD,UAAU;EACV,aAAa;EACb,kBAAkB;EAClB,mBAAmB,EAAE,mDAAmD;EACxE,mBAAmB,EAAE,iDAAiD;EACtE,gBAAgB,EAAE,sCAAsC;AAC1D;;AAEA,2CAA2C;AAC3C;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW,EAAE,oCAAoC;EACjD,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,kBAAkB,EAAE,qCAAqC;AAC3D;;AAEA;EACE,aAAa;EACb,UAAU;EACV,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB,EAAE,sCAAsC;AAC7D;;AAEA,0EAA0E;;;AAG1E;EACE,2BAA2B,EAAE,kCAAkC;EAC/D,iBAAiB,EAAE,6BAA6B;AAClD;;;AAGA,sDAAsD;AACtD;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,sGAAsG;;AAEtG,wCAAwC;AACxC;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,yCAAyC,EAAE,sCAAsC;AACnF;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B,EAAE,+BAA+B;EAC9D,gCAAgC;EAChC,2CAA2C;AAC7C;;AAEA,+DAA+D;AAC/D;EACE,yBAAyB,EAAE,yCAAyC;EACpE,sBAAsB;EACtB,kCAAkC;EAClC,wCAAwC;EACxC,sBAAsB;EACtB,wBAAwB;EACxB,8BAA8B;EAC9B,6BAA6B,EAAE,+BAA+B;EAC9D,0BAA0B,EAAE,uBAAuB;EACnD,mCAAmC,EAAE,iCAAiC;AACxE;;AAEA;EACE,yBAAyB,EAAE,yCAAyC;EACpE,mCAAmC;EACnC,kCAAkC;EAClC,wCAAwC;EACxC,sBAAsB;EACtB,wBAAwB;EACxB,8BAA8B;EAC9B,6BAA6B,EAAE,+BAA+B;EAC9D,0BAA0B,EAAE,uBAAuB;EACnD,aAAa,EAAE,iCAAiC;AAClD;;AAEA,wCAAwC;AACxC;EACE,wBAAwB;EACxB,mBAAmB;EACnB,yCAAyC;EACzC,sBAAsB;AACxB;;AAEA,wCAAwC;AACxC;EACE,wBAAwB;EACxB,oBAAoB;EACpB,yCAAyC;EACzC,sBAAsB;AACxB;;;AAGA,yCAAyC;AACzC;;EAEE,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;;EAEE,oCAAoC;EACpC,6BAA6B;AAC/B;;;AAGA,gHAAgH;;AAEhH;EACE,cAAc;EACd,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,wCAAwC;EACxC,iBAAiB,EAAE,6BAA6B;AAClD;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,uBAAuB;EACvB,6BAA6B;EAC7B,4BAA4B;EAC5B,0BAA0B;EAC1B,0BAA0B;EAC1B,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;EACzB,oCAAoC;EACpC,6BAA6B;EAC7B,2BAA2B;EAC3B,0BAA0B;EAC1B,0BAA0B;EAC1B,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;AACtC;;;AAGA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,YAAY;EACZ,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,SAAO;AACT;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,SAAO;EACP,kBAAkB;AACpB;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA,yBAAyB;AACzB;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,sBAAsB;EACtB,aAAa;EACb,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE,WAAW;AACb;;AAEA;;EAEE,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA,kCAAkC;AAClC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA,8BAA8B;AAC9B;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iBAAiB,EAAE,4DAA4D;EAC/E,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc,EAAE,oBAAoB;EACpC,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,YAAY;EACZ,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,yBAAyB,EAAE,gBAAgB;EAC3C,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,cAAc,EAAE,cAAc;EAC9B,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,wCAAwC;AACxC;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,kDAAkD;AAClD;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,0DAA0D;AAC1D;EACE,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,kDAAkD;AAClD;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,aAAa;AACf;;;;AAIA;EACE,kCAAkC;EAClC,yBAAyB;EACzB,oCAAoC;EACpC,6BAA6B;EAC7B,4BAA4B;EAC5B,0BAA0B;EAC1B,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,uBAAuB;EACvB,6BAA6B;EAC7B,2BAA2B;EAC3B,0BAA0B;EAC1B,0BAA0B;EAC1B,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;AACtC;;AAEA,2CAA2C;AAC3C;EACE,qBAAqB;EACrB,uBAAuB;EACvB,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA,qCAAqC;AACrC;EACE,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA,uEAAuE;;AAEvE;EACE,aAAa;EACb,uBAAuB,EAAE,wBAAwB;EACjD,SAAS,EAAE,0BAA0B;EACrC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gCAAgC,EAAE,4BAA4B;EAC9D,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,mBAAmB;AACrB;;AAEA;;EAEE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sCAAsC;EACtC,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;EAEE,0BAA0B,EAAE,6BAA6B;AAC3D;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,YAAY;EACZ,WAAW;EACX,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,WAAW;EACX,2BAA2B;EAC3B,6BAA6B;EAC7B,yBAAyB;EACzB,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,gBAAgB;EAChB,6BAA6B;AAC/B;;;AAGA,gDAAgD;;;AAGhD,sCAAsC;AACtC;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE;aACW;AACb;;AAEA,qBAAqB;AACrB;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,gBAAgB;;EAEhB,4BAA4B;EAC5B,oCAAoC;EACpC,0BAA0B;EAC1B,gCAAgC;EAChC,iCAAiC;EACjC,wBAAwB;AAC1B;;AAEA,iFAAiF;AACjF,uBAAuB;AACvB,iFAAiF;;AAEjF;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,WAAW;EACX,yBAAyB;AAC3B;;AAEA,uDAAuD;AACvD;EACE,yBAAyB;EACzB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;AACxB;;AAEA,+BAA+B;AAC/B;EACE,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,SAAO;AACT;;AAEA;EACE,aAAa;EACb,uBAAuB,EAAE,kCAAkC;EAC3D,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,SAAS;EACT,yCAAyC;AAC3C;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,wCAAwC;AAC1C;;AAEA,oDAAoD;AACpD;EACE,SAAO;EACP,UAAU;EACV,cAAc;AAChB;;AAEA,iFAAiF;AACjF,SAAS;AACT,iFAAiF;;AAEjF,6BAA6B;AAC7B;EACE,QAAQ;EACR,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,mBAAmB;AACnB;EACE,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;EACd,eAAe;EACf,eAAe;EACf,UAAU;EACV,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,uBAAuB,EAAE,yCAAyC;AACpE;;AAEA,4BAA4B;AAC5B;EACE,wCAAwC;EACxC,wBAAwB;EACxB,YAAY;EACZ,2BAA2B;AAC7B;;AAEA,6CAA6C;AAC7C;EACE,aAAa;AACf;;AAEA,iFAAiF;AACjF,iDAAiD;AACjD,iFAAiF;;AAEjF,4BAA4B;AAC5B;EACE,aAAa,EAAE,oCAAoC;EACnD,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,qBAAqB;AACvB;;AAEA,uCAAuC;AACvC;EACE,YAAY,EAAE,yCAAyC;EACvD,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,gBAAgB;EAChB,qBAAqB,EAAE,mBAAmB;AAC5C;;AAEA,gDAAgD;AAChD;EACE,wBAAwB;EACxB,wBAAwB;EACxB,iCAAiC;EACjC,uBAAuB;EACvB,0BAA0B;EAC1B,2BAA2B,EAAE,qCAAqC;EAClE,6BAA6B;;EAE7B,+BAA+B;EAC/B,4BAA4B,EAAE,oCAAoC;;EAElE,+BAA+B;EAC/B,wBAAwB;EACxB,6BAA6B;EAC7B,6BAA6B;EAC7B,4BAA4B;EAC5B,iCAAiC;EACjC,0BAA0B;EAC1B,2BAA2B;EAC3B,sBAAsB;EACtB,mBAAmB;EACnB,8BAA8B;;EAE9B,6BAA6B;EAC7B,qBAAqB;EACrB,gCAAgC;EAChC,wBAAwB;AAC1B;;AAEA;EACE,UAAU,EAAE,mBAAmB;AACjC;;AAEA;EACE,mBAAmB,EAAE,mCAAmC;AAC1D;;AAEA;EACE,yBAAyB,EAAE,0CAA0C;EACrE,kBAAkB,EAAE,oBAAoB;AAC1C;;AAEA;EACE,yBAAyB,EAAE,6BAA6B;AAC1D;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,6BAA6B;EAC7B,6BAA6B,EAAE,2BAA2B;AAC5D;;AAEA;EACE,YAAY,EAAE,0BAA0B;EACxC,oBAAoB;EACpB,qBAAqB;EACrB,uBAAuB;EACvB,wCAAwC;EACxC,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,iFAAiF;AACjF,+BAA+B;AAC/B,iFAAiF;;AAEjF,oCAAoC;AACpC;EACE,8BAA8B;AAChC;;AAEA,+CAA+C;AAC/C;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,gBAAgB;EAChB,SAAS,EAAE,iCAAiC;EAC5C,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,4BAA4B;AAC5B;EACE,UAAU,EAAE,6BAA6B;EACzC,mBAAmB,EAAE,uBAAuB;EAC5C,iBAAiB;EACjB,kBAAkB,EAAE,uBAAuB;AAC7C;;AAEA,4CAA4C;AAC5C;EACE,uBAAuB,EAAE,kDAAkD;AAC7E;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa,EAAE,6BAA6B;EAC5C,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,mCAAmC;EACnC,wCAAwC;EACxC,eAAe;AACjB;;AAEA,iFAAiF;AACjF,2BAA2B;AAC3B,iFAAiF;;AAEjF;EACE,YAAY;EACZ,WAAW;AACb;;AAEA,oBAAoB;AACpB;EACE,kBAAkB,EAAE,+BAA+B;EACnD,SAAS,EAAE,0BAA0B;EACrC,WAAW,EAAE,4BAA4B;EACzC,aAAa,EAAE,iCAAiC;EAChD,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA,iBAAiB;AACjB;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA,sCAAsC;AACtC;EACE,mCAAmC;EACnC,2BAA2B;EAC3B,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,wCAAwC;EACxC,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;EACtC,wBAAwB;AAC1B;;AAEA,iFAAiF;AACjF,kBAAkB;AAClB,iFAAiF;;AAEjF,qBAAqB;AACrB;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,oCAAoC;EACpC,aAAa;EACb,kBAAkB;EAClB,0CAA0C;EAC1C,eAAe;EACf,aAAa,EAAE,8BAA8B;EAC7C,oBAAoB,EAAE,kCAAkC;AAC1D;;AAEA,wBAAwB;AACxB;EACE,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,8BAA8B;AAC9B;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,iBAAiB;EACjB,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,0CAA0C;EAC1C,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,UAAU;EACV,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA,iFAAiF;AACjF,yBAAyB;AACzB,iFAAiF;;AAEjF;EACE,gBAAgB;EAChB,aAAa;EACb,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;;AAEA,iFAAiF;AACjF,wCAAwC;AACxC,iFAAiF;;AAEjF,8CAA8C;AAC9C;EACE,eAAe,EAAE,yBAAyB;EAC1C,iBAAiB,EAAE,uBAAuB;EAC1C,kBAAkB,EAAE,oBAAoB;EACxC,mBAAmB,EAAE,oDAAoD;EACzE,WAAW,EAAE,uBAAuB;AACtC;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA,iFAAiF;AACjF,6BAA6B;AAC7B,iFAAiF;;AAEjF;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA,mBAAmB;AACnB;EACE,uBAAuB;EACvB,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,qBAAqB,EAAE,sBAAsB;AAC/C;;AAEA,qBAAqB;AACrB;EACE,WAAW;AACb;;;;AAIA,qBAAqB;AACrB;EACE,qBAAqB;EACrB,uBAAuB;EACvB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,UAAU;EACV,eAAe;EACf,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;;EAEE,SAAO;EACP,aAAa;EACb,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,8DAA8D;AAChE;;AAEA;;EAEE,SAAO;EACP,aAAa;EACb,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,8DAA8D;AAChE;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,WAAW;AACb;;AAEA,iFAAiF;AACjF,iCAAiC;AACjC,iFAAiF;;AAEjF;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,UAAU,GAAG,+BAA+B;EAC5C,gBAAgB;EAChB,aAAa;EACb,eAAe,GAAG,sCAAsC;EACxD,2BAA2B,GAAG,6BAA6B;EAC3D,mBAAmB,EAAE,+BAA+B;EACpD,yBAAyB;EACzB,SAAS,EAAE,+BAA+B;EAC1C,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,oBAAoB,GAAG,yCAAyC;EAChE,mBAAmB,EAAE,8BAA8B;EACnD,mBAAmB,EAAE,oDAAoD;AAC3E;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,SAAO;EACP,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA,iFAAiF;AACjF,0BAA0B;AAC1B,iFAAiF;;AAEjF;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,0BAA0B;EAC1B,2BAA2B;EAC3B,uBAAuB;EACvB,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,0CAA0C;EAC1C,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kCAAkC;EAClC,WAAW;EACX,eAAe;EACf,SAAS;EACT,WAAW;EACX,cAAc,EAAE,8BAA8B;AAChD;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;;;AAIA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,4BAA4B;EAC5B,gCAAgC;EAChC,0BAA0B;EAC1B,oCAAoC;EACpC,6BAA6B;EAC7B,kCAAkC;AACpC;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,gCAAgC;CACjC;;AAED;EACE,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;;CAEC,wBAAwB;CACxB,8BAA8B;CAC9B,yCAAyC;AAC1C;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;CAC9B;;CAEA;EACC,oBAAkB;EAClB,4BAA4B;AAC9B;;;CAGC;EACC,gCAAgC;EAChC,qBAAqB;EACrB,uBAAuB;EACvB,4BAA4B;CAC7B;;CAEA,yCAAyC;AAC1C;;EAEE,wBAAwB;EACxB,8BAA8B;EAC9B,yCAAyC;AAC3C;;AAEA;;EAEE,sBAAsB;EACtB,wBAAwB;AAC1B;;CAEC,8BAA8B;CAC9B;EACC,wBAAwB;EACxB,8BAA8B;EAC9B,yCAAyC;EACzC,sBAAsB;CACvB;;AAED;EACE,4BAA4B;AAC9B;;AAEA;;;;;;CAMC,wBAAwB;CACxB,8BAA8B;CAC9B,8BAA8B;CAC9B,yCAAyC;CACzC,8BAA8B;AAC/B;;AAEA;;;CAGC,wBAAwB;CACxB,8BAA8B;CAC9B,yCAAyC;CACzC,sBAAsB;AACvB;;AAEA,iDAAiD;AACjD;EACE,gCAAgC;EAChC,6BAA6B;EAC7B,sBAAsB;EACtB,8BAA8B;CAC/B;;CAEA;EACC,gCAAgC;EAChC,uBAAuB;EACvB,uBAAuB;EACvB,4BAA4B;EAC5B,iCAAiC;CAClC;;AAED;EACE,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;EACxB,oCAAoC;EACpC,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;EAC5B,oCAAoC;EACpC,6BAA6B;EAC7B,kCAAkC;EAClC,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA,8BAA8B;AAC9B;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,uBAAuB;EACvB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,uBAAuB;CACxB;;AAED;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA,iFAAiF;AACjF,4CAA4C;AAC5C,iFAAiF;;AAEjF;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY,GAAG,wBAAwB;EACvC,aAAa,GAAG,yBAAyB;EACzC,oCAAoC,EAAE,gCAAgC;EACtE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc,EAAE,kCAAkC;EAClD,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,UAAU,EAAE,iBAAiB;EAC7B,cAAc,EAAE,oBAAoB;EACpC,gBAAgB,EAAE,mDAAmD;EACrE,iBAAiB;EACjB,aAAa;EACb,iBAAiB,EAAE,+BAA+B;EAClD,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,UAAU,EAAE,iBAAiB;EAC7B,cAAc,EAAE,oBAAoB;EACpC,gBAAgB,EAAE,mDAAmD;EACrE,iBAAiB;EACjB,aAAa;EACb,iBAAiB,EAAE,+BAA+B;EAClD,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,eAAe;EACf,SAAO;EACP,mBAAmB;EACnB,SAAS,EAAE,+BAA+B;EAC1C,mBAAmB,EAAE,qBAAqB;EAC1C,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,wCAAwC,EAAE,iBAAiB;EAC3D,uBAAuB,EAAE,2BAA2B;AACtD;;AAEA;EACE,UAAU;EACV,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS,EAAE,+BAA+B;EAC1C,mBAAmB,EAAE,qBAAqB;EAC1C,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,wCAAwC,EAAE,iBAAiB;EAC3D,uBAAuB,EAAE,2BAA2B;EACpD,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,SAAO;EACP,WAAW;AACb;;AAEA;EACE,WAAW,EAAE,gCAAgC;AAC/C;;AAEA;EACE,SAAO;EACP,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,UAAU,EAAE,iBAAiB;EAC7B,cAAc,EAAE,oBAAoB;EACpC,gBAAgB,EAAE,mDAAmD;EACrE,iBAAiB;EACjB,aAAa;EACb,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,uCAAuC;AACzC;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY,EAAE,iBAAiB;EAC/B,cAAc,EAAE,oBAAoB;EACpC,iBAAiB,EAAE,mDAAmD;EACtE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,iBAAiB,EAAE,+BAA+B;EAClD,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,iBAAiB,EAAE,+BAA+B;EAClD,aAAa;EACb,mBAAmB;AACrB;;AAEA,6DAA6D;AAC7D;EACE,aAAa;EACb,8BAA8B,EAAE,6BAA6B;EAC7D,uBAAuB,EAAE,gCAAgC;EACzD,SAAS,EAAE,6BAA6B;EACxC,aAAa;AACf;;AAEA,8CAA8C;AAC9C;EACE,SAAO,EAAE,+BAA+B;EACxC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW,EAAE,6BAA6B;EAC1C,gBAAgB,EAAE,mCAAmC;EACrD,gBAAgB;EAChB,WAAW,EAAE,mBAAmB;EAChC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY,EAAE,6BAA6B;EAC3C,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,iBAAiB;AACjB;EACE,UAAU;EACV,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,iCAAiC;AACjC;EACE,eAAe;AACjB;;AAEA,yDAAyD;AACzD;EACE,eAAe;EACf,aAAa;EACb,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS,EAAE,+BAA+B;EAC1C,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,8BAA8B;EAC9B,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA,iFAAiF;AACjF,sBAAsB;AACtB,iFAAiF;;AAEjF,mBAAmB;AACnB;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,aAAa,EAAE,yBAAyB;EACxC,gBAAgB,EAAE,4BAA4B;AAChD;;AAEA,UAAU;AACV;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS,EAAE,oBAAoB;AACjC;;AAEA;EACE,YAAY;EACZ,UAAU,EAAE,WAAW;AACzB;;AAEA;EACE,YAAY;EACZ,UAAU,EAAE,0BAA0B;AACxC;;AAEA;EACE,aAAa;EACb,UAAU,EAAE,gBAAgB;AAC9B;;AAEA,iFAAiF;AACjF,kBAAkB;AAClB,iFAAiF;;AAEjF,uBAAuB;AACvB;EACE,qBAAqB;EACrB,gCAAgC;EAChC,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA,mBAAmB;AACnB;EACE,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;;EAEE,6BAA6B;EAC7B,YAAY;AACd;;AAEA,qBAAqB;AACrB;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;;EAEE,mCAAmC;AACrC;;AAEA,mBAAmB;AACnB;EACE,6BAA6B;EAC7B,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;;EAEE,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;;EAEE,mCAAmC;AACrC;;AAEA,oBAAoB;AACpB;;EAEE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB,EAAE,+BAA+B;EACnD,eAAe;AACjB;;AAEA,iFAAiF;AACjF,yDAAyD;AACzD,iFAAiF;;AAEjF,0BAA0B;AAC1B;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,SAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA,wBAAwB;AACxB;EACE,WAAW;EACX,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA,2BAA2B;AAC3B;EACE,qBAAqB,EAAE,gBAAgB;EACvC,uBAAuB;EACvB,mCAAmC,EAAE,oBAAoB;AAC3D;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,cAAc,EAAE,sBAAsB;AACxC;;AAEA,uBAAuB;AACvB;EACE,YAAY;EACZ,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,WAAW;EACX,WAAW;AACb;;AAEA,wCAAwC;AACxC;EACE,WAAW;EACX,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA,gCAAgC;AAChC;EACE,qBAAqB,EAAE,gBAAgB;EACvC,uBAAuB;EACvB,mCAAmC,EAAE,oBAAoB;AAC3D;;AAEA,wCAAwC;AACxC;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,WAAW;;EAEX,yBAAyB;EACzB,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;;AAEA,kEAAkE;AAClE;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;;;AAIA,mDAAmD;AACnD;EACE,yBAAyB,EAAE,uBAAuB;EAClD,sBAAsB;EACtB,0BAA0B;;EAE1B,4BAA4B,EAAE,mCAAmC;EACjE,mCAAmC;EACnC,iCAAiC;AACnC;;AAEA;EACE,4CAA4C;EAC5C,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,yCAAyC,EAAE,gCAAgC;CAC5E;;AAED;EACE,sBAAsB;EACtB,uBAAuB;EACvB,kCAAkC;EAClC,oCAAoC;EACpC,2BAA2B,EAAE,2BAA2B;EACxD,mDAAmD;EACnD,2CAA2C;EAC3C,eAAe;AACjB;;AAEA,oBAAoB;AACpB;EACE;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,qBAAqB;CACtB;;;AAGD;EACE,6BAA6B;EAC7B,qBAAqB;EACrB,oCAAoC;EACpC,uBAAuB;EACvB,0BAA0B;EAC1B,2BAA2B;EAC3B,6BAA6B;EAC7B,uCAAuC;AACzC;;AAEA;EACE,sBAAsB;EACtB,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA,+DAA+D;AAC/D;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA,0CAA0C;AAC1C;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,mCAAmC;AACrC;;AAEA,6CAA6C;AAC7C;EACE,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;AACpB;;AAEA,+BAA+B;AAC/B;EACE,gCAAgC;EAChC,2BAA2B;EAC3B,6BAA6B;EAC7B,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;EAChC,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,oDAAoD;AACpD;;;;EAIE,wBAAwB;EACxB,8BAA8B;EAC9B,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA,mEAAmE;AACnE;;EAEE,wBAAwB;AAC1B;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;;EAEE,6BAA6B;EAC7B,oBAAoB;EACpB,wBAAwB;EACxB,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,mDAAmD;AACnD;EACE,8BAA8B;AAChC;;AAEA,kEAAkE;AAClE;EACE,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA,+FAA+F;;AAE/F,oCAAoC;AACpC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,iBAAiB;EACjB,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA,sEAAsE;AACtE;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,iBAAiB,EAAE,0BAA0B;EAC7C,UAAU;EACV,SAAS,EAAE,wBAAwB;EACnC,gBAAgB;AAClB;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,SAAO;AACT;;AAEA;EACE,gBAAgB,EAAE,yBAAyB;EAC3C,WAAW;EACX,YAAY;AACd;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS,EAAE,wBAAwB;EACnC,SAAO;AACT;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,SAAS,EAAE,wBAAwB;EACnC,WAAW;AACb;;AAEA,4BAA4B;AAC5B;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,mBAAmB,EAAE,uBAAuB;EAC5C,kBAAkB,EAAE,6BAA6B;EACjD,qBAAqB;EACrB,0CAA0C,EAAE,6BAA6B;EACzE,iBAAiB,EAAE,yBAAyB;EAC5C,kBAAkB;EAClB,mEAAmE;AACrE;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB,EAAE,wBAAwB;AAC/C;;AAEA;EACE,WAAW,EAAE,wBAAwB;EACrC,YAAY,EAAE,wBAAwB;EACtC,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe,EAAE,wBAAwB;EACzC,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,aAAa;EACb,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,YAAY,EAAE,sEAAsE;EACpF,YAAY;AACd;;AAEA,2BAA2B;AAC3B;EACE;IACE,UAAU;IACV,SAAS;EACX;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,SAAS;EACX;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,8HAA8H;;AAE9H,+BAA+B;AAC/B;EACE,yBAAyB;EACzB,WAAW;EACX,aAAa;EACb,aAAa;EACb,8BAA8B;AAChC;;AAEA,kDAAkD;AAClD;EACE,SAAO;AACT;;AAEA;EACE,SAAO;EACP,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,yCAAyC;EACzC,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,SAAS;EACT,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,wCAAwC;AAC1C;;AAEA,2BAA2B;AAC3B;EACE;IACE,SAAO;EACT;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;AACF;;;AAGA,6LAA6L;AAC7L,iCAAiC;AACjC;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,aAAa;AACf;;AAEA,sCAAsC;AACtC;EACE,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA,mBAAmB;AACnB;EACE,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA,0BAA0B;AAC1B;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA,uBAAuB;AACvB;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA,YAAY;AACZ;EACE,yBAAyB;EACzB,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,0BAA0B;AAC1B;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,kBAAkB;AAClB;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,YAAY;AACd;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,aAAa;EACb,8BAA8B;AAChC;;;AAGA,0FAA0F;AAC1F,uCAAuC;AACvC;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,2BAA2B;EAC3B,YAAY;EACZ,UAAU;EACV,sBAAsB;AACxB;;AAEA,8DAA8D;;AAE9D,4BAA4B;;AAE5B;EACE,uBAAuB;EACvB,sBAAsB;EACtB,iCAAiC;EACjC,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA,kCAAkC;AAClC;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,2BAA2B;EAC3B,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;AACjB;;AAEA,4CAA4C;;AAE5C,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,MAAM;EACN,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB,EAAE,2BAA2B;EAC9C,mBAAmB,EAAE,0BAA0B;AACjD;;AAEA,mDAAmD;AACnD;EACE,iBAAiB,EAAE,2CAA2C;EAC9D,2BAA2B,EAAE,uBAAuB;EACpD,iBAAiB,EAAE,gCAAgC;EACnD,UAAU,EAAE,6CAA6C;AAC3D;;;AAGA;EACE,oCAAoC;EACpC,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA,mBAAmB;AACnB;EACE,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;AACjB;;AAEA,qCAAqC;AACrC;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA,kDAAkD;AAClD;EACE,YAAY;AACd;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,0BAA0B;EAC1B,6BAA6B,EAAE,sBAAsB;EACrD,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,yCAAyC;AACzC;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA,qCAAqC;AACrC;EACE,kBAAkB;EAClB,2BAA2B,EAAE,wBAAwB;EACrD,eAAe;EACf,mBAAmB;EACnB,eAAe;AACjB;;AAEA,6BAA6B;;AAE7B;EACE,oCAAoC;EACpC,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA,mBAAmB;AACnB;EACE,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;AACjB","sourcesContent":["/* ============================================================================ */\n/* Main Layout Styles */\n/* ============================================================================ */\n\n/* Main header styles */\n.main-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 15px 30px;\n  border-bottom: 1px solid #ccc;\n  background-color: white;\n  height: 80px; /* Fixed height for header */\n}\n\n.logo {\n  display: flex;\n  align-items: center;\n}\n\n.logo img {\n  height: 50px;\n  width: auto;\n}\n\n.main-nav {\n  display: flex;\n  gap: 30px;\n}\n\n.main-nav a {\n  color: #333;\n  text-decoration: none;\n  font-size: 16px;\n  font-weight: 500;\n  padding: 8px 0;\n  position: relative;\n  transition: color 0.2s ease;\n}\n\n.main-nav a:hover {\n  color: #3275c7;\n}\n\n.main-nav a.active {\n  color: #3275c7;\n}\n\n.main-nav a.active:after {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 2px;\n  background-color: #3275c7;\n}\n\n\n\n\n/* Disabled buttons */\n.btn:disabled,\n.btn.disabled,\nbutton:disabled,\nbutton.disabled {\n  background-color: #e2e8f0 !important; /* Light gray background */\n  color: #a0aec0 !important; /* Muted text color */\n  border-color: #e2e8f0 !important; /* Light border */\n  cursor: not-allowed !important; /* Show \"not-allowed\" cursor on hover */\n  opacity: 0.7 !important; /* Reduced opacity */\n  box-shadow: none !important; /* Remove any shadow effects */\n  pointer-events: none; /* Prevent hover effects */\n}\n\n/* For primary buttons with the blue background */\n.btn-primary:disabled,\n.btn-primary.disabled,\n.calculate-button:disabled,\n.calculate-button.disabled,\n.save-changes-button:disabled,\n.save-changes-button.disabled,\n.export-map-button:disabled,\n.export-map-button.disabled {\n  background-color: #a3bfdf !important; /* Lighter version of your blue */\n  color: #e5eef8 !important; /* Light text on blue */\n  border-color: #a3bfdf !important;\n}\n\n/* For secondary/outline buttons */\n.btn-outline:disabled,\n.btn-outline.disabled,\n.criteria-secondary-button:disabled,\n.criteria-secondary-button.disabled,\n.add-button:disabled,\n.add-button.disabled {\n  background-color: transparent !important;\n  color: #a0aec0 !important;\n  border-color: #cbd5e0 !important;\n}\n\n/* For hover states (just in case pointer-events doesn't work) */\n.btn:disabled:hover,\n.btn.disabled:hover,\nbutton:disabled:hover,\nbutton.disabled:hover {\n  background-color: #e2e8f0 !important;\n  color: #a0aec0 !important;\n  border-color: #e2e8f0 !important;\n}\n\n\nbody > div[role=\"presentation\"] {\n  z-index: 9999 !important;\n}\n\n\n/* New class for dropdown containers */\n.select-container-wrapper {\n  position: relative;\n  margin-bottom: 16px;\n  z-index: auto !important;\n}\n\n.ReactModal__Content {\n  overflow: visible !important; /* Allow dropdowns to overflow */\n}\n\n.criteria-content-wrapper .builder-heading {\n  display: block;\n  position: relative;\n  z-index: 1 !important; /* Keep z-index very low so it doesn't interfere with dropdowns */\n}\n\n\n/* Expandable section styles */\n.expandable-container {\n  width: 100%;\n  margin-bottom: 20px;\n}\n\n/* Z-index management for proper layering */\n.header-expandable {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 6px 0; /* Reduced padding to decrease space between title and line */\n  border-bottom: 1px solid #e2e8f0;\n  background-color: white;\n  z-index: 5; /* Lower z-index so dropdowns can appear above it */\n  position: relative;\n  margin-left: -25px; /* Extend to full width of parent */\n  margin-right: -25px;\n  padding-left: 25px;\n  padding-right: 25px;\n  height: 20px;\n  padding-top: 0px;\n  padding-bottom: 0px;\n  width: calc(100% + 50px); /* Full width including the negative margins */\n  z-index: 99999 !important;\n}\n\n.expand-toggle-button {\n  position: relative;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #1976d2;\n  font-size: 16px;\n  height: 30px;\n  width: 30px;\n  border-radius: 0px;\n  transition: background-color 0.2s ease;\n  padding-top: 0px;\n  padding-bottom: 0px;\n  margin: 0px;\n  bottom: 10px;\n}\n\n.expand-toggle-button:hover {\n  background-color: #f0f5ff;\n}\n\n.expandable {\n  overflow: visible;\n  transition: max-height 0.3s ease-in-out, opacity 0.3s ease-in-out, margin-top 0.3s ease-in-out;\n  height: auto;\n  z-index: 1 !important;\n}\n\n.expandable.expanded {\n  max-height: 1500px; /* Large enough to contain content */\n  opacity: 1;\n  margin-top: 0;\n  position: relative;\n  overflow-y: visible; /* Ensure content is visible even if it overflows */\n  padding-bottom: 5px; /* Add padding to ensure Save button is visible */\n  padding-top: 5px; /* Add more space after the top line */\n}\n\n/* Full-width border for expanded section */\n.expandable.expanded::after {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: -25px; /* Extend beyond container padding */\n  right: -25px;\n  height: 1px;\n  background-color: #e2e8f0;\n  margin-bottom: 3px; /* Space between content and border */\n}\n\n.expandable.collapsed {\n  max-height: 0;\n  opacity: 0;\n  margin-top: -20px;\n  pointer-events: none;\n  margin-bottom: 10px; /* Add space after collapsed section */\n}\n\n/* Adjust content wrapper position and ensure criteria header visibility */\n\n\n.expandable.collapsed + .criteria-content-wrapper {\n  max-height: 100% !important; /* Adjust based on header height */\n  padding-top: 15px; /* Add space for the header */\n}\n\n\n/* Ensure dropdown menu container stays above header */\n.css-b62m3t-container {\n  position: relative;\n  z-index: 20 !important;\n}\n\n/* CSS Fix for Builder.tsx - Footer and Scrolling ---------------------------------------------------*/\n\n/* Make the content wrapper scrollable */\n.criteria-content-wrapper {\n  flex-grow: 1 !important;\n  overflow-y: auto !important;\n  max-height: calc(100% - 120px) !important; /* Leave space for footer and header */\n}\n\n.criteria-content-wrapper::-webkit-scrollbar {\n  width: 8px !important;\n}\n\n.criteria-content-wrapper::-webkit-scrollbar-track {\n  background: #EEF0F2 !important;\n}\n\n.criteria-content-wrapper::-webkit-scrollbar-thumb {\n  background-color: #CBD5E0 !important;\n  border-radius: 4px !important;\n}\n\n.contact-page-right .scrollable-content {\n  flex-grow: 1 !important;\n  overflow-y: auto !important;\n  overflow-x: hidden !important;\n  padding-right: 5px !important;\n  margin-right: -5px !important; /* Pull scrollbar to the edge */\n  scrollbar-width: thin !important;\n  scrollbar-color: #CBD5E0 #EEF0F2 !important;\n}\n\n/* Fix the footer to the bottom of the contact-page-right div */\n.builder-fixed-footer {\n  flex: 0 0 60px !important; /* Height of 60px, don't grow or shrink */\n  width: 100% !important;\n  background-color: white !important;\n  border-top: 1px solid #e2e8f0 !important;\n  z-index: 10 !important;\n  display: flex !important;\n  align-items: center !important;\n  margin-left: -25px !important; /* Counter the parent padding */\n  padding: 0 25px !important; /* Add padding inside */\n  width: calc(100% + 50px) !important; /* Full width including margins */\n}\n\n.explorer-fixed-footer {\n  flex: 0 0 60px !important; /* Height of 60px, don't grow or shrink */\n  width: calc(100% + 50px) !important;\n  background-color: white !important;\n  border-top: 1px solid #e2e8f0 !important;\n  z-index: 10 !important;\n  display: flex !important;\n  align-items: center !important;\n  margin-left: -25px !important; /* Counter the parent padding */\n  padding: 0 25px !important; /* Add padding inside */\n  height: 100px; /* Full width including margins */\n}\n\n/* Style for the buttons in the footer */\n.builder-fixed-footer .button-group {\n  display: flex !important;\n  gap: 5px !important;\n  justify-content: space-between !important;\n  width: 100% !important;\n}\n\n/* Style for the buttons in the footer */\n.explorer-fixed-footer .button-group {\n  display: flex !important;\n  gap: 20px !important;\n  justify-content: space-between !important;\n  width: 100% !important;\n}\n\n\n/* Scrollbar styles for webkit browsers */\n.scrollable-content::-webkit-scrollbar,\n.criteria-content-wrapper::-webkit-scrollbar {\n  width: 8px !important;\n  background: #EEF0F2 !important;\n}\n\n.scrollable-content::-webkit-scrollbar-thumb,\n.criteria-content-wrapper::-webkit-scrollbar-thumb {\n  background-color: #CBD5E0 !important;\n  border-radius: 4px !important;\n}\n\n\n/* Criteria Inputs Styling ------------------------------------------------------------------------------------*/\n\n.criteria-content-wrapper .builder-heading {\n  display: block;\n  position: relative;\n  z-index: 5;\n}\n\n.expandable.collapsed + .criteria-content-wrapper {\n  max-height: calc(100% - 60px) !important;\n  padding-top: 15px; /* Add space for the header */\n}\n\n.save-changes-button {\n  background-color: #1976d2 !important;\n  color: white !important;\n  border: none !important;\n  border-radius: 4px !important;\n  padding: 8px 16px !important;\n  cursor: pointer !important;\n  font-size: 14px !important;\n  font-weight: 500 !important;\n  height: 38px !important;\n}\n\n.save-changes-button:hover {\n  background-color: #164677 !important;\n}\n\n.criteria-secondary-button {\n  background-color: white !important;\n  color: #1976d2 !important;\n  border: 1px solid #1976d2 !important;\n  border-radius: 4px !important;\n  padding: 1px 8px !important;\n  cursor: pointer !important;\n  font-size: 14px !important;\n  font-weight: 500 !important;\n  height: 38px !important;\n}\n\n.criteria-secondary-button:hover {\n  background-color: #f0f5ff !important;\n}\n\n\n.criteria-input-container {\n  margin-bottom: 8px;\n  position: static !important;\n  z-index: auto !important;\n}\n\n.criteria-input {\n  width: 100%;\n  padding: 8px 12px;\n  font-size: 14px;\n  color: #333;\n  border: 1px solid #e2e8f0;\n  border-radius: 4px;\n  background-color: white;\n  height: 38px;\n  box-sizing: border-box;\n}\n\n.criteria-input:focus {\n  border-color: #1976d2;\n  outline: none;\n  box-shadow: 0 0 0 1px rgba(26, 83, 135, 0.2);\n}\n\n.criteria-input-clear {\n  position: absolute;\n  top: 50%;\n  right: 10px;\n  transform: translateY(-50%);\n  background: none;\n  border: none;\n  color: #718096;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  height: 16px;\n  width: 16px;\n  z-index: 2;\n}\n\n.criteria-input-group {\n  display: flex;\n  gap: 8px;\n  width: 100%;\n}\n\n.criteria-input-group .criteria-input {\n  flex: 1;\n}\n\n/* Range inputs */\n.criteria-range-container {\n  display: flex;\n  gap: 8px;\n  width: 100%;\n}\n\n.criteria-range-input {\n  flex: 1;\n  position: relative;\n}\n\n/* Custom dropdown styling */\n.criteria-dropdown {\n  position: relative;\n  width: 100%;\n}\n\n.criteria-dropdown-select {\n  width: 100%;\n  padding: 8px 12px;\n  font-size: 14px;\n  color: #333;\n  border: 1px solid #e2e8f0;\n  border-radius: 4px;\n  background-color: white;\n  appearance: none;\n  height: 38px;\n  box-sizing: border-box;\n}\n\n.criteria-dropdown-select:focus {\n  border-color: #1976d2;\n  outline: none;\n}\n\n.criteria-dropdown::after {\n  content: \"▼\";\n  font-size: 10px;\n  color: #718096;\n  position: absolute;\n  right: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  pointer-events: none;\n}\n\n/* MUI Select overrides */\n.criteria-mui-select {\n  width: 100%;\n  height: 38px;\n  font-size: 14px;\n}\n\n.criteria-mui-select .MuiOutlinedInput-root {\n  height: 38px;\n  border-radius: 4px;\n}\n\n.criteria-mui-select .MuiOutlinedInput-notchedOutline {\n  border-color: #e2e8f0;\n}\n\n.criteria-mui-select .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {\n  border-color: #cbd5e1;\n}\n\n.criteria-mui-select .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {\n  border-color: #1976d2;\n}\n\n.criteria-mui-select .MuiSelect-select {\n  padding: 8px 12px;\n  height: 38px;\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n}\n\n/* React-select overrides */\n.criteria-react-select {\n  width: 100%;\n}\n\n.criteria-react-select .css-13cymwt-control,\n.criteria-react-select .css-t3ipsp-control {\n  min-height: 38px;\n  border-color: #e2e8f0;\n  box-shadow: none;\n}\n\n.criteria-react-select .css-t3ipsp-control:hover {\n  border-color: #cbd5e1;\n}\n\n.criteria-react-select .css-t3ipsp-control:focus-within {\n  border-color: #1976d2;\n  box-shadow: 0 0 0 1px rgba(26, 83, 135, 0.2);\n}\n\n/* Chip styling for multi-select */\n.criteria-chip {\n  display: inline-flex;\n  align-items: center;\n  background: #e2e8f0;\n  border-radius: 16px;\n  padding: 2px 8px;\n  margin: 2px;\n  font-size: 12px;\n}\n\n.criteria-chip-delete {\n  margin-left: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  line-height: 1;\n}\n\n/* Export Map button styling */\n.export-map-button {\n  background-color: #1976d2;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  padding: 8px 16px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  height: 38px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 16px;\n}\n\n.export-map-button:hover {\n  background-color: #164677;\n}\n\n/* Add to your App.css */\n.criteria-buttons-layout {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n  margin-top: 15px;\n}\n\n.top-buttons-row {\n  display: flex;\n  gap: 10px;\n}\n\n.middle-button-row {\n  margin: 10px 0;\n}\n\n.criteria-buttons-row {\n  display: flex;\n  gap: 10px;\n  margin-top: 15px;\n}\n\n.export-button-container {\n  margin-top: -52px; /* Adjust this value as needed to align with other buttons */\n  display: flex;\n  justify-content: center;\n}\n\n.builder-section-title {\n  font-size: 16px;\n  font-weight: 600;\n  color: #1976d2; /* Blue text color */\n  margin-bottom: 3px;\n  margin-top: 0px;\n  display: block;\n}\n\n.builder-input-container {\n  position: static !important;\n  z-index: auto !important;\n}\n\n.builder-clear-button {\n  position: absolute;\n  top: 50%;\n  right: 10px;\n  transform: translateY(-50%);\n  background: none;\n  border: none;\n  color: #718096;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  height: 16px;\n  width: 16px;\n  z-index: 2;\n}\n\n.builder-action-button {\n  background-color: #1976d2; /* Blue button */\n  color: white;\n  border: none;\n  border-radius: 4px;\n  padding: 8px 16px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  margin-right: 10px;\n  margin-top: 10px;\n}\n\n.builder-criteria-button {\n  background-color: white;\n  color: #1976d2; /* Blue text */\n  border: 1px solid #1976d2; \n  border-radius: 4px;\n  padding: 8px 16px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  margin-top: 10px;\n}\n\n.builder-heading {\n  font-size: 20px;\n  font-weight: bold;\n  color: #1976d2;\n  margin-bottom: 5px;\n  position: relative; \n}\n\n/* Override styles for DynamicSelector */\n.filter-section-title {\n  font-size: 16px;\n  font-weight: 600;\n  color: #1976d2 !important;\n  margin-top: 10px;\n  display: block;\n}\n\n/* Override styles for MUI components in Builder */\n.contact-page-right .MuiInputBase-root {\n  border-radius: 4px;\n}\n\n.contact-page-right .MuiOutlinedInput-notchedOutline {\n  border-color: #e2e8f0;\n}\n\n.contact-page-right .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {\n  border-color: #cbd5e1;\n}\n\n.contact-page-right .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {\n  border-color: #1976d2;\n}\n\n/* Customize the comparison selector in CriteriaSelector */\n.comparison-selector {\n  background-color: white;\n  border: 1px solid #e2e8f0;\n  border-radius: 4px;\n  padding: 8px 16px;\n}\n\n.comparison-selector:hover {\n  border-color: #cbd5e1;\n}\n\n/* Customize the value input in CriteriaSelector */\n.criteria-value-input {\n  width: 100%;\n  padding: 8px;\n  border: 1px solid #e2e8f0;\n  border-radius: 4px;\n}\n\n.criteria-value-input:focus {\n  border-color: #1976d2;\n  outline: none;\n}\n\n\n\n.add-button {\n  background-color: white !important;\n  color: #1976d2 !important;\n  border: 1px solid #1976d2 !important;\n  border-radius: 4px !important;\n  padding: 10px 8px !important;\n  cursor: pointer !important;\n  font-size: 14px !important;\n  font-weight: 500 !important;\n}\n\n.add-button:hover {\n  background-color: #f0f5ff !important;\n}\n\n.calculate-button {\n  background-color: #1976d2 !important;\n  color: white !important;\n  border: none !important;\n  border-radius: 4px !important;\n  padding: 0px 8px !important;\n  cursor: pointer !important;\n  font-size: 14px !important;\n  font-weight: 500 !important;\n  height: 38px !important;\n}\n\n.calculate-button:hover {\n  background-color: #164677 !important;\n}\n\n/* Custom styling for parameter selectors */\n.p-4.border.rounded-md {\n  padding: 0 !important;\n  border: none !important;\n  border-radius: 0 !important;\n  margin-bottom: 16px !important;\n}\n\n.p-4.border.rounded-md p.font-semibold.mb-2 {\n  font-size: 16px !important;\n  font-weight: 600 !important;\n  color: #1976d2 !important;\n  margin-bottom: 8px !important;\n}\n\n/* Override for the criteria editor */\n.criteria-row {\n  border: 1px solid #e2e8f0 !important;\n  border-radius: 4px !important;\n}\n\n/* ------------------------------------------------------------------ */\n\n.upload-buttons-container {\n  display: flex;\n  justify-content: center; /* Centers the buttons */\n  gap: 10px; /* Space between buttons */\n  margin-top: 10px;\n}\n\n.custom-dataset-section {\n  margin-top: 15px;\n  margin-bottom: 15px;\n  padding-top: 10px;\n  border-top: 1px solid #eaeaea;\n}\n\n.custom-dataset-title {\n  font-size: 16px;\n  font-weight: 600;\n  color: #1976d2;\n  margin-bottom: 12px;\n}\n\n.upload-data-section {\n  padding-bottom: 100px !important; /* Large padding at bottom */\n  margin-bottom: 60px !important;\n}\n\n.export-container {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  margin-bottom: 15px;\n}\n\n.export-container button,\n.custom-dataset-section button {\n  background-color: #1976d2;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  padding: 8px 16px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n  height: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.export-container button:hover,\n.custom-dataset-section button:hover {\n  background-color:  #132a4d; /* Slightly darker on hover */\n}\n\n.overlay-selector {\n  margin-top: 15px;\n}\n\nhtml, body, #root {\n  overflow: hidden;\n  padding: 0;\n  height: 100%;\n  width: 100%;\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.MuiTab-root {\n  font-size: 12px;\n  font-weight: 500;\n  text-transform: none;\n  color: #333;\n  padding: 4px 8px !important;\n  border-radius: 3px !important; \n  transition: all 0.2s ease;\n  min-height: 30px !important;\n  max-height: 30px !important;\n}\n\n.MuiTab-root.Mui-selected {\n  background-color: #1a365d;\n  color: white !important;\n  font-weight: 600;\n  border: 1px solid transparent;\n}\n\n\n/* ------------------------------------------- */\n\n\n/* Reset some default browser styles */\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n/* Global Variables */\n:root {\n  --light-gray: #dae5ef;\n  --blue: #2d4778;\n  --green: #c1ff81;\n  --gray: #9aa7b2;\n  --light-blue: #aed8ff;\n  --white: #ffffff;\n\n  --primary-color: var(--blue);\n  --secondary-color: var(--light-blue);\n  --text-color: var(--white);\n  --hover-color: var(--light-gray);\n  --active-color: var(--light-gray);\n  --transition-speed: 0.3s;\n}\n\n/* ============================================================================ */\n/* Main Layout Styles */\n/* ============================================================================ */\n\n.logo {\n  display: flex;\n  align-items: center;\n}\n\n.logo img {\n  height: 50px;\n  width: auto;\n}\n\n.main-nav {\n  display: flex;\n  gap: 30px;\n}\n\n.main-nav a {\n  color: #333;\n  text-decoration: none;\n  font-size: 16px;\n  font-weight: 500;\n  padding: 8px 0;\n  position: relative;\n  transition: color 0.2s ease;\n}\n\n.main-nav a:hover {\n  color: #3275c7;\n}\n\n.main-nav a.active {\n  color: #3275c7;\n}\n\n.main-nav a.active:after {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 2px;\n  background-color: #3275c7;\n}\n\n/* Main content wrapper - takes full remaining height */\n.content-wrapper {\n  background-color: #EEF0F2;\n  min-height: calc(100vh);\n  display: flex;\n  flex-direction: column;\n}\n\n/* Tools navigation container */\n.tools-container {\n  background-color: white;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n}\n\n.tools-nav ul {\n  display: flex;\n  background-color: white; /* Changed from #f2f4f6 to white */\n  border-radius: 25px;\n  padding: 5px;\n  list-style: none;\n  margin: 0;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);\n}\n\n.tools-nav li {\n  margin: 0;\n  padding: 0;\n}\n\n.tools-nav a {\n  display: block;\n  padding: 8px 20px;\n  color: #506580;\n  text-decoration: none;\n  font-size: 14px;\n  font-weight: 500;\n  border-radius: 20px;\n  transition: all 0.2s ease;\n}\n\n.tools-nav a:hover {\n  background-color: rgba(0, 0, 0, 0.05);\n}\n\n.tools-nav a.active {\n  background-color: #DEEBFF;\n  color: #3275c7;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n/* Tool content area - takes full remaining height */\n.tool-content {\n  flex: 1;\n  padding: 0;\n  overflow: auto;\n}\n\n/* ============================================================================ */\n/* Tabs */\n/* ============================================================================ */\n\n/* Style the Tabs container */\n.MuiTabs-root {\n  gap: 4px;\n  min-height: 40px;\n  background-color: white;\n}\n\n/* Style each Tab */\n.MuiTab-root {\n  min-height: 40px;\n  text-transform: none;\n  color: #718096;\n  padding: 0 16px;\n  font-size: 14px;\n  opacity: 1;\n  border: 1px solid #E2E8F0;\n  margin-left: 0;\n}\n\n.MuiTab-root:first-child {\n  margin-left: 0;\n}\n\n.MuiTab-root:hover {\n  background-color: rgba(26, 54, 93, 0.1);\n}\n\n.MuiTab-root.Mui-selected {\n  color: white;\n  background-color: #1976d2;\n  border: 1px solid black; /* Border matching the background color */\n}\n\n/* Style for disabled Tabs */\n.MuiTab-root.Mui-disabled {\n  background-color: var(--gray) !important;\n  color: var(--light-gray);\n  opacity: 0.7;\n  border-radius: 0 !important;\n}\n\n/* Remove the default indicator (underline) */\n.MuiTabs-indicator {\n  display: none;\n}\n\n/* ============================================================================ */\n/* Page Layouts - Explorer, Builder, Comparator */\n/* ============================================================================ */\n\n/* Container for all pages */\n.contact-page-container {\n  height: 100vh; /* Ensure full height minus header */\n  overflow: hidden;\n  background-color: #EEF0F2;\n  display: grid;\n  grid-template-columns: 3fr 1fr;\n  gap: 20px;\n  padding: 0 !important;\n}\n\n/* Left section for Tabs and MapImage */\n.contact-page-left {\n  height: 100%; /* Increase the height by adding pixels */\n  display: flex;\n  flex-direction: column;\n  padding: 0 !important;\n  overflow: hidden;\n  padding: 0 !important; /* Remove padding */\n}\n\n/* Right section for Selectors, Parameters etc */\n.contact-page-right {\n  /* Essential structure */\n  display: flex !important;\n  flex-direction: column !important;\n  height: 100% !important;\n  max-height: 100%!important;\n  overflow: hidden !important; /* Prevent container from scrolling */\n  position: relative !important;\n  \n  /* Remove conflicting padding */\n  padding-bottom: 0 !important; /* Remove the 130px bottom padding */\n  \n  /* Keep other existing styles */\n  transform: translateZ(0);\n  padding-left: 25px !important;\n  padding-right: 5px !important; \n  padding-top: 20px !important;\n  box-sizing: border-box !important;\n  margin-right: 0 !important;\n  border-radius: 0 !important;\n  width: 100% !important;\n  right: 0 !important;\n  background: #ffffff !important;\n  \n  /* Fix scrollbar appearance */\n  scrollbar-width: thin;\n  scrollbar-color: #CBD5E0 #EEF0F2;\n  z-index: auto !important;\n}\n\n.contact-page-right::-webkit-scrollbar {\n  width: 8px; /* Thin scrollbar */\n}\n\n.contact-page-right::-webkit-scrollbar-track {\n  background: #EEF0F2; /* Light background for the track */\n}\n\n.contact-page-right::-webkit-scrollbar-thumb {\n  background-color: #CBD5E0; /* Grayish color for the scrollbar thumb */\n  border-radius: 4px; /* Rounded corners */\n}\n\n.contact-page-right::-webkit-scrollbar-thumb:hover {\n  background-color: #A0AEC0; /* Slightly darker on hover */\n}\n\n.scrollable-content {\n  flex: 1 1 auto !important;\n  overflow-y: auto !important;\n  padding-right: 5px !important;\n  margin-right: -5px !important; /* Pull scrollbar to edge */\n}\n\n.contact-page-map-container {\n  height: 100%; /* Change to full height */\n  margin: 0 !important;\n  padding: 0 !important;\n  border: none !important;\n  background-color: transparent !important;\n  box-shadow: none !important;\n}\n\n.leaflet-container {\n  width: 100%;\n  height: 100%;\n  padding: 0px !important;\n  margin: 0px !important;\n}\n\n.map-resolution-container {\n  display: flex;\n  align-items: center;\n  background-color: white;\n  border-bottom: 1px solid #e0e4e8;\n  padding: 0 20px;\n}\n\n.map-resolution-title {\n  font-size: 14px;\n  font-weight: 600;\n  color: #2d3748;\n  margin-right: 20px;\n  white-space: nowrap;\n}\n\n/* ============================================================================ */\n/* Comparator-specific styles */\n/* ============================================================================ */\n\n/* Adjust grid for comparator page */\n.contact-page-container.comparator {\n  grid-template-columns: 5fr 1fr;\n}\n\n/* Updated to use flex-wrap and new structure */\n.contact-page-maps {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  margin-top: 20px;\n  gap: 20px; /* Gap between rows and columns */\n  transition: width 0.3s ease-in-out;\n}\n\n.map-column {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n/* Top row map (first map) */\n.map-column:first-child {\n  width: 50%; /* Same width as other maps */\n  margin-bottom: 20px; /* Space between rows */\n  margin-left: auto;\n  margin-right: auto; /* Center the top map */\n}\n\n/* Bottom row maps (second and third maps) */\n.map-column:not(:first-child) {\n  width: calc(50% - 10px); /* Each takes approximately half width minus gap */\n}\n\n.map-column h3 {\n  margin-bottom: 10px;\n  text-align: center;\n}\n\n.comparator-page-map-container {\n  width: 100%;\n  height: 400px; /* Same height for all maps */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  background-color: var(--light-gray);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  max-width: 100%;\n}\n\n/* ============================================================================ */\n/* Map and Overlay Styles */\n/* ============================================================================ */\n\n.map-container {\n  height: 100%;\n  width: 100%;\n}\n\n/* Overlay buttons */\n.overlay-buttons {\n  position: absolute; /* Ensures it's above the map */\n  top: 10px; /* Position from the top */\n  right: 10px; /* Position from the right */\n  z-index: 1000; /* Make sure it's above the map */\n  display: flex;\n  gap: 5px;\n}\n\n.overlay-button {\n  background-color: white;\n  border: 1px solid #ccc;\n  padding: 8px;\n  border-radius: 5px;\n  cursor: pointer;\n  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.2);\n}\n\n.overlay-button.active {\n  background-color: #007bff;\n  color: white;\n}\n\n/* Button Group */\n.btn-group {\n  display: inline-flex;\n  border-radius: 4px;\n  overflow: hidden;\n  margin-top: 10px;\n}\n\n.btn-group .btn {\n  border-radius: 0;\n  margin: 0;\n}\n\n.btn-group .btn:not(:last-child) {\n  border-right: 1px solid var(--gray);\n}\n\n.btn-group .btn:first-child {\n  border-top-left-radius: 6px;\n  border-bottom-left-radius: 6px;\n}\n\n.btn-group .btn:last-child {\n  border-top-right-radius: 6px;\n  border-bottom-right-radius: 6px;\n}\n\n/* Toggle Button for OverlaySelector */\n.btn-toggle {\n  background-color: var(--light-gray);\n  color: var(--primary-color);\n  font-weight: bold;\n  width: 130px;\n}\n\n.btn-toggle:hover {\n  background-color: var(--secondary-color);\n  color: var(--primary-color);\n}\n\n.btn-toggle.selected {\n  background-color: var(--primary-color);\n  color: var(--text-color);\n}\n\n/* ============================================================================ */\n/* Legend Styles */\n/* ============================================================================ */\n\n/* Legend container */\n.overlay-legend {\n  position: absolute;\n  bottom: 20px;\n  left: 20px;\n  background: rgba(255, 255, 255, 0.8);\n  padding: 10px;\n  border-radius: 8px;\n  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.2);\n  font-size: 14px;\n  z-index: 1000; /* Ensure it's above the map */\n  pointer-events: auto; /* Ensure interaction is enabled */\n}\n\n/* Each legend section */\n.legend-section {\n  margin-bottom: 10px;\n}\n\n/* Title of each legend */\n.legend-title {\n  font-weight: bold;\n  margin-bottom: 5px;\n}\n\n/* Legend item */\n.legend-item {\n  display: flex;\n  align-items: center;\n  margin-bottom: 4px;\n}\n\n/* Colored square for legend */\n.legend-color {\n  width: 16px;\n  height: 16px;\n  margin-right: 5px;\n  border-radius: 3px;\n  display: inline-block;\n}\n\n/* Standalone legend container */\n.legend-container {\n  padding: 10px;\n  background: white;\n  border: 1px solid #ccc;\n  width: 400px;\n  text-align: left;\n  border-radius: 5px;\n  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.2);\n  margin-top: 10px;\n  margin-bottom: 10px;\n  display: flex;\n}\n\n.legend-gradient {\n  margin-top: 5px;\n  width: 400px;\n  height: 20px;\n  display: flex;\n}\n\n.legend-values {\n  display: flex;\n  justify-content: space-between;\n  width: 400px;\n  font-size: 12px;\n}\n\n.legend-list {\n  list-style: none;\n  padding: 10;\n  margin: 10;\n  display: flex;\n}\n\n.legend-color-box {\n  width: 40px;\n  height: 20px;\n  display: inline-block;\n  margin-right: 5px;\n  border: 1px solid black;\n}\n\n/* ============================================================================ */\n/* Feature Table Styles */\n/* ============================================================================ */\n\n.feature-table-container {\n  margin-top: 10px;\n  padding: 10px;\n  background: white;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.2);\n}\n\n.feature-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.feature-table th,\n.feature-table td {\n  border: 1px solid #ccc;\n  padding: 5px;\n  text-align: left;\n}\n\n/* ============================================================================ */\n/* Dynamic Selectors and Form Controls */\n/* ============================================================================ */\n\n/* Label style for the text above the slider */\n.slider-label {\n  font-size: 1rem; /* Adjust the font size */\n  font-weight: bold; /* Make the text bold */\n  text-align: center; /* Center the text */\n  margin-bottom: 10px; /* Add some space between the label and the slider */\n  color: #333; /* Set the text color */\n}\n\n/* Range slider styles */\n.range-slider-container {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  padding: 20px;\n  border: 1px solid #ccc;\n  border-radius: 8px;\n}\n\n.sliders-section {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}\n\n.slider-wrapper {\n  display: flex;\n  align-items: center;\n  margin-bottom: 5px;\n}\n\n.slider-label {\n  width: 40px;\n  font-size: 14px;\n}\n\n.slider-label-right {\n  text-align: right;\n}\n\n.slider-input-wrapper {\n  flex-grow: 1;\n  margin: 0 10px;\n}\n\n.slider-input {\n  width: 100%;\n}\n\n/* ============================================================================ */\n/* Criteria Selector Styles */\n/* ============================================================================ */\n\n.container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n}\n\n/* Expression Box */\n.expression-box {\n  border: 2px solid black;\n  padding: 16px;\n  min-width: 250px;\n  text-align: center;\n  font-family: monospace;\n  white-space: pre-line; /* Keeps line breaks */\n}\n\n/* Placeholder text */\n.placeholder {\n  color: gray;\n}\n\n\n\n/* Calculate Button */\n.calculate-button {\n  background: limegreen;\n  border: 2px solid black;\n  padding: 8px 16px;\n  cursor: pointer;\n  font-weight: bold;\n  display: flex;\n  align-items: center;\n}\n\n/* Trash Button */\n.trash-button {\n  color: red;\n  font-size: 20px;\n  background: none;\n  border: none;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n}\n\n/* Trash Button hover */\n.trash-button:hover {\n  color: red;\n  font-size: 20px;\n  background: lightgray;\n  border: none;\n}\n\n.parameter-addition-button {\n  display: flex;\n  justify-content: center;\n  margin-bottom: 0;\n}\n\n.parameter-addition-button-save {\n  display: flex;\n  justify-content: right;\n  margin-bottom: 0;\n  padding-right: 10px;\n}\n\n.add-button {\n  padding: 8px 16px;\n  background-color: limegreen;\n  color: white;\n  border-radius: 4px;\n}\n\n.criteria-selector {\n  padding: 20px;\n  font-family: Arial, sans-serif;\n  background-color: #f9f9f9;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  max-width: 400px;\n  margin: 20px auto;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.criteria-selector input[type=\"text\"] {\n  width: 100%;\n  padding: 8px;\n  margin-bottom: 10px;\n  font-size: 16px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  outline: none;\n  transition: border-color 0.3s ease;\n}\n\n.criteria-selector input[type=\"text\"]:focus {\n  border-color: #007bff;\n}\n\n.operator-buttons,\n.logical-operators {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 10px;\n}\n\n.operator-buttons button.base,\n.logical-operators button.base {\n  flex: 1;\n  padding: 10px;\n  font-size: 16px;\n  cursor: pointer;\n  background-color: #3b34c8;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  transition: background-color 0.2s ease, border-color 0.2s ease;\n}\n\n.operator-buttons button,\n.logical-operators button {\n  flex: 1;\n  padding: 10px;\n  font-size: 16px;\n  cursor: pointer;\n  background-color: #3b34c8;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  transition: background-color 0.2s ease, border-color 0.2s ease;\n}\n\n.operator-buttons button:hover,\n.logical-operators button:hover {\n  background-color: #007bff; \n}\n\n.operator-buttons button.active,\n.logical-operators button.active {\n  background-color: #007bff;\n  color: white;\n  border-color: #007bff;\n}\n\n.logical-operators .trash-button {\n  background-color: #f8d7da;\n  color: #721c24;\n}\n\n.logical-operators .trash-button:hover {\n  background-color: #f5c6cb;\n}\n\n.number-input {\n  width: 100%;\n  padding: 8px;\n  margin-bottom: 10px;\n  font-size: 16px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  outline: none;\n}\n\n.number-input:focus {\n  border-color: #007bff;\n}\n\n.criteria-rows {\n  border-top: 1px solid #ddd;\n  padding-top: 10px;\n}\n\n.criteria-row {\n  padding: 8px 0;\n  font-size: 16px;\n  color: #333;\n}\n\n/* ============================================================================ */\n/* Drag & Drop Component Styles */\n/* ============================================================================ */\n\n.drag-drop-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n  width: 90%;\n}\n\n.bucket {\n  border: 2px dashed #ccc;\n  padding: 5px;\n  width: 95%;  /* Ensure it takes full width */\n  min-height: 50px;\n  display: flex;\n  flex-wrap: wrap;  /* Allows wrapping if items overflow */\n  justify-content: flex-start;  /* Aligns items to the left */\n  align-items: center; /* Ensures vertical centering */\n  background-color: #f9f9f9;\n  gap: 10px; /* Adds spacing between items */\n  height: auto;\n}\n\n.fruit-item {\n  padding: 5px 10px;\n  background-color: #ffcc80;\n  border: 1px solid #5549d8;\n  border-radius: 5px;\n  cursor: grab;\n  font-size: 12px;\n  display: inline-flex;  /* Ensures items are displayed in a row */\n  align-items: center; /* Centers text inside items */\n  white-space: nowrap; /* Prevents text from breaking into multiple lines */\n}\n\n.drop-areas {\n  min-height: 50px;\n  display: flex;\n  width: 100%;\n  gap: 10px;\n  padding: 5px;\n  min-height: 50px;\n  text-align: center;\n  background-color: #e3f2fd;\n  flex: 1; \n  flex-direction: row;\n}\n\n.drop-area {\n  min-height: 50px;\n  border: 2px solid #888;\n  padding: 5px 10px;\n  max-width: 300px;\n  width: 100%;\n  border-radius: 5px;\n  cursor: grab;\n  font-size: 12px;\n}\n\n/* ============================================================================ */\n/* Import & Modal Styles */\n/* ============================================================================ */\n\n.import-button {\n  background-color: #1a365d;\n  color: white;\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: none;\n  cursor: pointer;\n  font-size: 14px !important;\n  font-weight: 500 !important;\n  height: 36px !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n}\n\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  width: 100vw;\n  height: 100vh;\n}\n\n.modal-content {\n  background-color: white;\n  border-radius: 8px;\n  padding: 24px;\n  width: 450px;\n  position: relative;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  z-index: 1001;\n}\n\n.close-button {\n  position: absolute;\n  background: none;\n  border: none;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 4px;\n  background: transparent !important;\n  color: #666;\n  font-size: 16px;\n  top: 10px;\n  right: 10px;\n  z-index: 10002; /* Higher than modal content */\n}\n\n.modal-title {\n  font-weight: 600;\n  color: #1a365d;\n  font-size: 18px;\n  margin-bottom: 20px;\n}\n\n\n\n.form-group {\n  margin-bottom: 20px;\n}\n\n.form-label {\n  font-weight: 500;\n  color: #1a365d;\n  margin-bottom: 8px;\n  display: block;\n}\n\n.form-input {\n  width: 100%;\n  padding: 8px;\n  border: 1px solid #e2e8f0;\n  border-radius: 4px;\n}\n\n.button-group {\n  margin-top: 5px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  margin-bottom: 5px;\n  flex-wrap: wrap;\n}\n\n.type-button {\n  padding: 6px 12px !important;\n  margin-right: 8px !important;\n  display: inline-block !important;\n  font-size: 14px !important;\n  border: 1px solid #e2e8f0 !important;\n  border-radius: 4px !important;\n  background-color: white !important;\n}\n\n.color-selector {\n  background-color: #1a365d !important;\n  color: white !important;\n  border-color: #1a365d !important;\n }\n\n.type-button.active {\n  background-color: #1a365d;\n  color: white;\n  border-color: #1a365d;\n}\n\n.type-button.inactive {\n  background-color: white;\n  color: #4a5568;\n}\n\n.color-preview {\n  flex-grow: 1;\n  height: 24px;\n  border-radius: 4px;\n  border: 1px solid #e2e8f0;\n}\n\n.scheme-select .MuiSelect-select,\n.form-group .MuiOutlinedInput-root {\n display: flex !important;\n align-items: center !important;\n justify-content: space-between !important;\n}\n\n.form-group .MuiSelect-select .color-text {\n  flex: 0 0 auto !important;\n  margin-right: 10px !important;\n }\n\n .color-preview-container {\n  flex: 1 !important;\n  margin-left: 10px !important;\n}\n\n\n .form-group .MuiSelect-select .color-preview {\n  display: inline-block !important;\n  width: 60% !important;\n  height: 24px !important;\n  margin-left: auto !important;\n }\n \n /* For standard select if not using MUI */\n.form-group select,\n.form-input {\n  display: flex !important;\n  align-items: center !important;\n  justify-content: space-between !important;\n}\n\n.form-group .MuiSelect-select,\n.form-group .MuiOutlinedInput-root {\n  width: 100% !important;\n  z-index: auto !important;\n}\n \n /* Direct approach if needed */\n .color-scheme-option {\n  display: flex !important;\n  align-items: center !important;\n  justify-content: space-between !important;\n  width: 100% !important;\n }\n\n.MuiSelect-select {\n  padding: 8px 14px !important;\n}\n\n.MuiSelect-select,\n.css-1dimb5e-singleValue,\n.css-1s2u09g-control,\n.css-13cymwt-control,\n.form-input,\n.color-select-option {\n display: flex !important;\n flex-direction: row !important;\n align-items: center !important;\n justify-content: space-between !important;\n white-space: nowrap !important;\n}\n\n.MuiMenuItem-root,\n.css-10wo9uf-option,\n.dropdown-option {\n display: flex !important;\n align-items: center !important;\n justify-content: space-between !important;\n width: 100% !important;\n}\n\n/* Make sure text and gradient are on same line */\n.scheme-name {\n  display: inline-block !important;\n  margin-right: 10px !important;\n  width: auto !important;\n  white-space: nowrap !important;\n }\n\n .color-gradient {\n  display: inline-block !important;\n  width: 150px !important;\n  height: 24px !important;\n  margin-left: auto !important;\n  vertical-align: middle !important;\n }\n\n.MuiMenuItem-root {\n  padding: 8px 14px !important;\n}\n\n.modal-footer {\n  display: flex !important;\n  justify-content: flex-end !important;\n  gap: 10px !important;\n  margin-top: 20px !important;\n}\n\n.cancel-button {\n  padding: 8px 16px !important;\n  border: 1px solid #e2e8f0 !important;\n  border-radius: 4px !important;\n  background-color: white !important;\n  cursor: pointer !important;\n  color: #4a5568 !important;\n}\n\n/* File upload input styling */\n.file-input {\n  border: 1px solid #e2e8f0 !important;\n  border-radius: 4px !important;\n  padding: 8px !important;\n  width: 100% !important;\n  display: block !important;\n}\n\n.save-button {\n  background-color: #1a365d !important;\n  color: white !important;\n  border: none !important;\n }\n\n.scheme-select {\n  display: flex !important;\n  flex-direction: row !important;\n  align-items: center !important;\n}\n\n.scheme-select .MuiSelect-select {\n  padding: 8px 14px !important;\n  background-color: white;\n}\n\n.scheme-select .MuiOutlinedInput-notchedOutline {\n  border-color: #e2e8f0 !important;\n}\n\n.scheme-select:hover .MuiOutlinedInput-notchedOutline {\n  border-color: #cbd5e1 !important;\n}\n\n/* ============================================================================ */\n/* User-Defined Metric & Custom Components */\n/* ============================================================================ */\n\n.modal-overlay-sc {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;  /* Full viewport width */\n  height: 100vh;  /* Full viewport height */\n  background-color: rgba(0, 0, 0, 0.5); /* Semi-transparent background */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  overflow: auto; /* Prevents background scrolling */\n  flex-direction: column;\n  z-index: 1001;\n}\n\n.modal-title-sc {\n  color: #1a365d;\n  margin-bottom: 2px;\n}\n\n.modal-content-sc {\n  width: 90%; /* Adjust width */\n  max-width: 90%; /* Limit max width */\n  max-height: 80vh; /* Prevent the modal from exceeding screen height */\n  background: white;\n  padding: 10px;\n  overflow-y: false; /* Enables vertical scrolling */\n  display: flex;\n  flex-direction: row;\n}\n\n.modal-content-second {\n  width: 90%; /* Adjust width */\n  max-width: 90%; /* Limit max width */\n  max-height: 80vh; /* Prevent the modal from exceeding screen height */\n  background: white;\n  padding: 10px;\n  overflow-y: false; /* Enables vertical scrolling */\n  display: flex;\n  flex-direction: column;\n}\n\n.selector-container-sc {\n  width: 50%;\n  display: flex;\n  flex-wrap: wrap;\n  flex: 1;\n  margin-bottom: 10px;\n  gap: 10px; /* Spacing between components */\n  background: #ffffff; /* White background */\n  padding: 20px;\n  border-radius: 12px;\n  border: 1px;\n  border-color: black;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Clean shadow */\n  align-items: flex-start; /* Align items to the top */\n}\n\n.parameter-container-sc {\n  width: 50%;\n  display: flex;\n  flex-wrap: wrap;\n  margin-bottom: 10px;\n  gap: 10px; /* Spacing between components */\n  background: #ffffff; /* White background */\n  padding: 20px;\n  border-radius: 12px;\n  border: 1px;\n  border-color: black;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Clean shadow */\n  align-items: flex-start; /* Align items to the top */\n  flex-direction: column;\n}\n\n.user-dataset-selector-sc {\n  flex: 1;\n  margin-right: 10px;\n}\n\n.map-selector-sc {\n  flex: 1;\n}\n\n.column-selector-sc {\n  flex: 1;\n  width: 100%;\n}\n\n.parameters-container {\n  width: 100%; /* Ensures it takes full width */\n}\n\n.parameter-selected-sc {\n  flex: 1;\n  width: 100%;\n}\n\n.equation-container {\n  align-items: center;\n  width: 90%; /* Adjust width */\n  max-width: 90%; /* Limit max width */\n  max-height: 80vh; /* Prevent the modal from exceeding screen height */\n  background: white;\n  padding: 10px;\n  display: flex;\n  flex-direction: row;\n}\n\n.equation-selected-sc {\n  padding: 10px;\n}\n\n.classification-container {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  gap: 20px;\n  margin-top: 20px;\n}\n\n.classification-item {\n  flex: 1;\n  background-color: #f8f9fa;\n  padding: 15px;\n  border-radius: 8px;\n  border: 1px solid #ddd;\n  transition: box-shadow 0.2s ease-in-out;\n}\n\n.classification-item:hover {\n  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);\n}\n\n.category-bar {\n  display: flex;\n  margin-top: 10px;\n  height: 20px;\n}\n\n.category {\n  text-align: center;\n  font-size: 12px;\n  font-weight: bold;\n  color: white;\n  padding: 3px;\n}\n\n.high {\n  background-color: red;\n}\n\n.medium {\n  background-color: orange;\n}\n\n.low {\n  background-color: green;\n}\n\n.reverse-btn {\n  margin-top: 10px;\n  background-color: #007bff;\n  color: white;\n  border: none;\n  padding: 5px 10px;\n  cursor: pointer;\n  border-radius: 5px;\n}\n\n.reverse-btn:hover {\n  background-color: #0056b3;\n}\n\n.equation-histogram-group {\n  width: 200px; /* Adjust width */\n  max-width: 90%; /* Limit max width */\n  max-height: 400px; /* Prevent the modal from exceeding screen height */\n  background: white;\n  padding: 10px;\n  border-radius: 12px;\n  border: 1px;\n  border-color: black;\n  overflow-y: false; /* Enables vertical scrolling */\n  display: flex;\n  flex-direction: row;\n}\n\n.equation-histogram-tile {\n  width: 200px; \n  max-width: 90%; \n  max-height: 80vh; \n  background: white;\n  padding: 10px;\n  border-radius: 12px;\n  border: 1px;\n  border-color: black;\n  overflow-y: false; /* Enables vertical scrolling */\n  display: flex;\n  flex-direction: row;\n}\n\n/* Parent container: Displays histogram groups horizontally */\n.histogram-container {\n  display: flex;\n  justify-content: space-between; /* Space between the groups */\n  align-items: flex-start; /* Align the groups at the top */\n  gap: 20px; /* Space between each group */\n  padding: 20px;\n}\n\n/* Each histogram group (stacked vertically) */\n.histogram-group {\n  flex: 1; /* Equal width for each group */\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  border: 2px solid #ddd;\n  padding: 15px;\n  border-radius: 10px;\n  background-color: #f9f9f9;\n  min-width: 250px;\n  width: 90%;\n}\n\n.histogram-chart {\n  position: relative;\n  margin-top: 10px;\n  width: 100%; /* Use full width of parent */\n  max-width: 600px; /* Prevent it from being too wide */\n  min-width: 300px;\n  height: 80%; /* Make it taller */\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.process-btn {\n  position: relative;\n  margin-top: 10px;\n  width: 150px; /* Use full width of parent */\n  align-items: center;\n  justify-content: center;\n}\n\n/* Input fields */\n.histogram-group input {\n  width: 80%;\n  padding: 8px;\n  margin: 10px 0;\n  border-radius: 5px;\n  border: 1px solid #ccc;\n  text-align: center;\n}\n\n/* Button styling */\n.histogram-group button {\n  background-color: #007bff;\n  color: white;\n  border: none;\n  padding: 8px 12px;\n  border-radius: 5px;\n  cursor: pointer;\n  margin-bottom: 10px;\n}\n\n.histogram-group button:hover {\n  background-color: #0056b3;\n}\n\n/* Ensure charts don't overflow */\n.histogram-group canvas {\n  max-width: 100%;\n}\n\n/* Parameters container for UserDefinedMetricParameters */\n.parameters-container {\n  margin-top: 2px;\n  padding: 10px;\n  width: 100%;\n}\n\n.parameter-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.parameter-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background-color: #f8f9fa;\n  padding: 5px 10px;\n  margin: 10px 0;\n  border-radius: 5px;\n  border: 1px solid #ddd;\n  transition: background-color 0.2s ease-in-out;\n}\n\n.parameter-row:hover {\n  background-color: #e9ecef;\n}\n\n.parameter-details {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.parameter-name {\n  font-weight: bold;\n  color: #333;\n}\n\n.parameter-info {\n  color: #555;\n}\n\n.delete-button {\n  color: red;\n  cursor: pointer;\n}\n\n/* Export styling */\n.export {\n  display: flex;\n  flex-direction: column;\n  gap: 20px; /* Spacing between components */\n  border-radius: 12px;\n}\n\n/* Function Builder */\n.function-builder {\n  padding: 20px;\n  font-family: Arial, sans-serif;\n  background-color: #f9f9f9;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  max-width: 400px;\n  margin: 20px auto;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.function-builder input[type=\"text\"] {\n  width: 100%;\n  padding: 8px;\n  margin-bottom: 10px;\n  font-size: 16px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  box-sizing: border-box;\n  outline: none;\n  transition: border-color 0.3s ease;\n}\n\n.function-builder input[type=\"text\"]:focus {\n  border-color: #007bff;\n}\n\n.scrollable-list {\n  border: 1px solid #ccc;\n  max-height: 200px;\n  overflow-y: auto;\n  border-radius: 4px;\n  margin-bottom: 10px;\n  background-color: #fff;\n  box-shadow: inset 0 2px 3px rgba(0, 0, 0, 0.1);\n}\n\n.scrollable-list div {\n  padding: 10px;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.scrollable-list div:hover {\n  background-color: #f0f0f0;\n}\n\n.scrollable-list div.selected {\n  background-color: #007bff;\n  color: white;\n}\n\n/* ============================================================================ */\n/* Intro Page Styles */\n/* ============================================================================ */\n\n/* Wave Container */\n.wave-container {\n  position: absolute;\n  bottom: 0;\n  width: 100%;\n  height: 150px; /* Ensure enough height */\n  overflow: hidden; /* Prevent extra scrolling */\n}\n\n/* Waves */\n.wave {\n  position: absolute;\n  width: 100%;\n  bottom: 0; /* Align to bottom */\n}\n\n.back-wave {\n  opacity: 0.6;\n  z-index: 3; /* Behind */\n}\n\n.front-wave {\n  opacity: 0.9;\n  z-index: 2; /* In front of back wave */\n}\n\n.middle-wave {\n  opacity: 0.75;\n  z-index: 1; /* Middle wave */\n}\n\n/* ============================================================================ */\n/* Button Styles */\n/* ============================================================================ */\n\n/* Button Base Styles */\n.btn {\n  display: inline-block;\n  font-family: \"Arial\", sans-serif;\n  font-weight: 600;\n  line-height: 1.5;\n  text-align: center;\n  text-decoration: none;\n  vertical-align: middle;\n  cursor: pointer;\n  user-select: none;\n  padding: 10px 20px;\n  border-radius: 6px;\n  transition: all 0.3s ease;\n  border: 2px solid transparent;\n}\n\n/* Primary Button */\n.btn-primary {\n  background-color: #1976d2;\n  color: var(--text-color);\n}\n\n.btn-primary:hover,\n.btn-primary:focus {\n  background-color: var(--blue);\n  opacity: 0.9;\n}\n\n/* Secondary Button */\n.btn-secondary {\n  background-color: var(--light-blue);\n  color: var(--primary-color);\n}\n\n.btn-secondary:hover,\n.btn-secondary:focus {\n  background-color: var(--light-gray);\n}\n\n/* Outline Button */\n.btn-outline {\n  background-color: transparent;\n  border-color: var(--primary-color);\n  color: var(--primary-color);\n}\n\n.btn-outline:hover,\n.btn-outline:focus {\n  background-color: var(--primary-color);\n  color: var(--white);\n}\n\n/* Ghost Button */\n.btn-ghost {\n  background-color: transparent;\n  color: var(--primary-color);\n}\n\n.btn-ghost:hover,\n.btn-ghost:focus {\n  background-color: var(--light-gray);\n}\n\n/* Disabled Button */\n.btn:disabled,\n.btn.disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Button Sizes */\n.btn-sm {\n  font-size: 12px;\n  padding: 6px 12px;\n}\n\n.btn-lg {\n  font-size: 16px;\n  padding: 12px 24px;\n}\n\nbutton {\n  margin-bottom: 2px; /* Space before the histogram */\n  margin-top: 2px;\n}\n\n/* ============================================================================ */\n/* Modern Selector Styles - Based on the provided image */\n/* ============================================================================ */\n\n/* Filter section styles */\n.filter-section {\n  margin-bottom: 5px;\n}\n\n.filter-section-title {\n  font-size: 14px;\n  font-weight: 600;\n  color: #333;\n  margin-bottom: 1px;\n  display: block;\n}\n\n/* Selected dataset item */\n.dataset-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background-color: #ffffff;\n  border: 1px solid #e2e8f0;\n  border-radius: 4px;\n  padding: 8px 12px;\n  margin-bottom: 8px;\n  width: 100%;\n}\n\n.dataset-item-text {\n  font-size: 14px;\n  color: #333;\n}\n\n.dataset-item-actions {\n  display: flex;\n  align-items: center;\n}\n\n.remove-btn {\n  background: none;\n  border: none;\n  color: #999;\n  cursor: pointer;\n  font-size: 14px;\n  padding: 0 4px;\n}\n\n.toggle-btn {\n  background: none;\n  border: none;\n  color: #999;\n  cursor: pointer;\n  font-size: 14px;\n  padding: 0 4px;\n}\n\n/* Radio Button Styles */\n.radio-group {\n  display: flex;\n  gap: 8px;\n  width: 100%;\n}\n\n.radio-option {\n  flex: 1;\n  position: relative;\n}\n\n.radio-option input[type=\"radio\"] {\n  position: absolute;\n  opacity: 0;\n  height: 0;\n  width: 0;\n}\n\n.radio-option label {\n  display: flex;\n  align-items: center;\n  padding: 4px;\n  background-color: #ffffff;\n  border: 1px solid #e2e8f0;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  color: #333;\n  width: 100%;\n  position: relative;\n  transition: all 0.2s ease;\n}\n\n/* Custom radio circle */\n.radio-option label::before {\n  content: \"\";\n  display: inline-block;\n  width: 16px;\n  height: 16px;\n  margin-right: 8px;\n  border: 1px solid #ccc;\n  border-radius: 50%;\n  background-color: white;\n}\n\n/* Selected radio styling */\n.radio-option input[type=\"radio\"]:checked + label::before {\n  border-color: #2563eb; /* Blue border */\n  background-color: white;\n  box-shadow: inset 0 0 0 4px #2563eb; /* Blue center dot */\n}\n\n/* Dropdown selector */\n.selector-dropdown {\n  position: relative;\n  width: 100%;\n  margin-bottom: 12px;\n}\n\n.selector-dropdown select {\n  appearance: none;\n  width: 100%;\n  padding: 8px 12px;\n  font-size: 14px;\n  border: 1px solid #e2e8f0;\n  border-radius: 4px;\n  background-color: white;\n  cursor: pointer;\n  color: #71717a; /* Placeholder color */\n}\n\n/* Arrow for dropdown */\n.selector-dropdown::after {\n  content: \"▼\";\n  font-size: 12px;\n  color: #999;\n  position: absolute;\n  right: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  pointer-events: none;\n}\n\n/* Grid layout for SSP options */\n.grid-radio-group {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 3px;\n  margin-bottom: 0px;\n}\n\n.grid-radio-option {\n  position: relative;\n}\n\n.grid-radio-option label {\n  display: flex;\n  align-items: center;\n  padding: 8px;\n  background-color: #ffffff;\n  border: 1px solid #e2e8f0;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  color: #333;\n  width: 100%;\n}\n\n/* Custom radio circle for grid layout */\n.grid-radio-option label::before {\n  content: \"\";\n  display: inline-block;\n  width: 16px;\n  height: 16px;\n  margin-right: 6px;\n  border: 1px solid #ccc;\n  border-radius: 50%;\n  background-color: white;\n}\n\n/* Selected grid radio styling */\n.grid-radio-option input[type=\"radio\"]:checked + label::before {\n  border-color: #2563eb; /* Blue border */\n  background-color: white;\n  box-shadow: inset 0 0 0 4px #2563eb; /* Blue center dot */\n}\n\n/* Hide default radio for grid options */\n.grid-radio-option input[type=\"radio\"] {\n  position: absolute;\n  opacity: 0;\n  height: 0;\n  width: 0;\n}\n\n.year-section-title {\n  align-items: center;\n  margin-bottom: 10px;\n  font-size: 14px;\n  font-weight: 600;\n  color: #333;\n\n  margin-left: 0 !important;\n  display: inline-block !important;\n  padding-bottom: 8px !important;\n}\n\n.year-range {\n  margin-left: 5px;\n  font-weight: normal;\n  color: #666;\n}\n\n/* Checkbox style for Log Scale - independent from year selector */\n.log-scale-wrapper {\n  display: flex;\n  align-items: center;\n  margin-top: 8px;\n  margin-bottom: 12px;\n}\n\n.log-scale-checkbox {\n  height: 16px;\n  width: 16px;\n  border: 1px solid #d1d5db;\n  border-radius: 4px;\n  margin-right: 8px;\n  cursor: pointer;\n}\n\n.log-scale-checkbox:checked {\n  background-color: #2563eb;\n  border-color: #2563eb;\n}\n\n.log-scale-label {\n  font-size: 14px;\n  color: #1976d2;\n  cursor: pointer;\n}\n\n\n\n/* Override MUI Slider styles to match the design */\n.MuiSlider-root {\n  color: #1a365d !important; /* Match button color */\n  height: 4px !important;\n  padding: 13px 0 !important;\n\n  margin-left: 10px !important; /* Important - shift slider right */\n  width: calc(100% - 20px) !important;\n  box-sizing: border-box !important;\n}\n\n.MuiSlider-root .MuiSlider-thumb {\n  transform: translate(-50%, -50%)  !important;\n  margin-top: 0  !important;\n  margin-left: 0  !important;\n}\n\n.MuiSlider-thumb[style*=\"left: 0%\"] {\n  transform: translate(0%, -50%) !important; /* Don't shift left when at 0% */\n }\n\n.MuiSlider-thumb {\n  width: 14px !important;\n  height: 14px !important;\n  background-color: white !important;\n  border: 2px solid #1a365d !important;\n  margin-top: -5px !important; /* Vertical alignment fix */\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2) !important;\n  transform: translate(-50%, -50%) !important;\n  cursor: pointer;\n}\n\n/* Fix for Firefox */\n@-moz-document url-prefix() {\n  .MuiSlider-thumb {\n    margin-top: -6px !important;\n  }\n}\n\n.MuiSlider-thumb:hover {\n  box-shadow: 0 0 0 8px rgba(26, 54, 93, 0.1) !important;\n}\n\n.MuiSlider-thumb:hover .MuiSlider-valueLabel {\n  opacity: 1 !important;\n }\n\n\n.MuiSlider-valueLabel {\n  transition: opacity 0.2s ease;\n  opacity: 0 !important;\n  background-color: #1a365d !important;\n  color: white !important;\n  font-size: 12px !important;\n  padding: 4px 6px !important;\n  border-radius: 4px !important;\n  transform: translateY(-20px) !important;\n}\n\n.MuiSlider-track {\n  height: 4px !important;\n  background-color: #2563eb !important;\n  border: none !important;\n}\n\n.MuiSlider-rail {\n  height: 4px !important;\n  background-color: #e2e8f0 !important;\n  border-radius: 2px !important;\n}\n\n.MuiSlider-mark {\n  height: 8px !important;\n  width: 1px !important;\n  background-color: #e2e8f0 !important;\n  margin-top: -2px !important;\n}\n\n.MuiSlider-markActive {\n  background-color: #2563eb !important;\n}\n\n.MuiSlider-markLabel {\n  color: #666 !important;\n  font-size: 12px !important;\n}\n\n/* Tailwind-like classes for Log Scale checkbox from Explorer */\n.flex.items-center.space-x-2 {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 8px;\n  margin-bottom: 16px;\n}\n\n.h-4.w-4.rounded.border-gray-300.text-blue-600.focus\\:ring-blue-500 {\n  height: 16px;\n  width: 16px;\n  border-radius: 4px;\n  border: 1px solid #d1d5db;\n  color: #2563eb;\n  cursor: pointer;\n}\n\n.h-4.w-4.rounded.border-gray-300.text-blue-600.focus\\:ring-blue-500:checked {\n  background-color: #2563eb;\n  border-color: #2563eb;\n}\n\n.text-sm.font-medium.text-gray-700 {\n  font-size: 14px;\n  font-weight: 500;\n  color: #4b5563;\n  cursor: pointer;\n}\n\n/* Styles for DynamicSelector */\n.p-4.border.rounded-md {\n  padding: 12px;\n  border: none;\n  border-radius: 4px;\n  margin-bottom: 16px;\n}\n\n.p-4.border.rounded-md p.font-semibold.mb-2 {\n  font-size: 14px;\n  font-weight: 600;\n  color: #333;\n  margin-bottom: 8px;\n}\n\n.p-4.border.rounded-md .space-y-2 {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n/* Modify the DynamicSelector Radio type */\n.p-4.border.rounded-md .flex.items-center.gap-2.cursor-pointer {\n  display: flex;\n  align-items: center;\n  position: relative;\n  padding-left: 24px;\n  cursor: pointer;\n}\n\n.p-4.border.rounded-md input[type=\"radio\"] {\n  position: absolute;\n  opacity: 0;\n  height: 0;\n  width: 0;\n}\n\n.p-4.border.rounded-md .flex.items-center.gap-2.cursor-pointer::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 16px;\n  height: 16px;\n  border: 1px solid #ccc;\n  border-radius: 50%;\n  background-color: white;\n}\n\n.p-4.border.rounded-md input[type=\"radio\"]:checked + .flex.items-center.gap-2.cursor-pointer::before {\n  border-color: #2563eb;\n  background-color: white;\n  box-shadow: inset 0 0 0 4px #2563eb;\n}\n\n/* Modify the DynamicSelector Dropdown type */\n.p-4.border.rounded-md select.p-2.border.rounded-md.w-full {\n  appearance: none;\n  width: 100%;\n  padding: 8px 12px;\n  font-size: 14px;\n  border: 1px solid #e2e8f0;\n  border-radius: 4px;\n  background-color: white;\n  cursor: pointer;\n  color: #71717a;\n}\n\n/* Enhance Select component */\n.searchable-selector {\n  margin-bottom: 8px;\n}\n\n/* React-select customization */\n.css-13cymwt-control {\n  border-color: #e2e8f0 !important;\n  box-shadow: none !important;\n  border-radius: 4px !important;\n  height: 38px !important;\n}\n\n.css-t3ipsp-control {\n  border-color: #d1d5db !important;\n  box-shadow: none !important;\n  height: 38px !important;\n}\n\n.css-1dimb5e-singleValue, \n.css-qbdosj-Input, \n.css-1jqq78o-placeholder {\n  color: #333 !important;\n}\n\n.css-166bipr-Input {\n  color: #333 !important;\n}\n\n/* Fix color scheme preview inside select dropdown */\n.MuiSelect-select .MuiBox-root,\n.css-w2ww2f,\n.form-group > div,\n.select-container {\n  display: flex !important;\n  flex-direction: row !important;\n  align-items: center !important;\n  width: 100% !important;\n}\n\n.color-option {\n  display: flex !important;\n  align-items: center !important;\n  width: 100% !important;\n}\n\n/* This ensures the dropdown menu will appear above other content */\n.select-container-wrapper .css-26l3qy-menu,\n.select-container-wrapper .css-1nmdiq5-menu {\n  z-index: 9999 !important;\n}\n\n.css-26l3qy-menu,\n.css-1nmdiq5-menu {\n  z-index: 9999 !important;\n}\n\nbody .css-26l3qy-menu,\nbody .css-1nmdiq5-menu {\n  position: absolute !important;\n  top: auto !important; \n  margin-top: 0 !important;\n  z-index: 9999 !important;\n}\n\nbody > div[role=\"presentation\"] {\n  z-index: 9999 !important;\n}\n\n/* Ensure dropdown opens above all other elements */\n.css-b62m3t-container {\n  position: relative  !important;\n}\n\n/* Force menu to portal to body to avoid stacking context issues */\n.select-dropdown-portal {\n  position: relative !important;\n}\n\n.builder-input-container {\n  position: static !important;\n  z-index: auto !important;\n}\n\n/* Intro Page Styles ------------------------------------------------------------------------ */\n\n/* Intro Page with Larger Elements */\n.intro-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  min-height: 100vh;\n  width: 100%;\n  background-color: #f9f9f9;\n  position: relative;\n  overflow: hidden;\n  padding: 0;\n  margin: 0;\n}\n\n/* Main content with side-by-side layout - positioned higher on page */\n.intro-content {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  width: 92%;\n  max-width: 1400px; /* Increased from 1200px */\n  z-index: 5;\n  gap: 60px; /* Increased from 40px */\n  margin-top: 12vh;\n}\n\n/* Logo container on the left */\n.intro-logo-container {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  flex: 1;\n}\n\n.intro-logo {\n  max-width: 450px; /* Increased from 380px */\n  width: 100%;\n  height: auto;\n}\n\n/* Cards container on the right */\n.intro-cards-container {\n  display: flex;\n  flex-direction: column;\n  gap: 30px; /* Increased from 20px */\n  flex: 1;\n}\n\n/* Row of cards */\n.cards-row {\n  display: flex;\n  gap: 30px; /* Increased from 20px */\n  width: 100%;\n}\n\n/* Individual card styling */\n.intro-card {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  background-color: white;\n  border-radius: 10px; /* Increased from 8px */\n  padding: 50px 25px; /* Increased from 40px 20px */\n  text-decoration: none;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05); /* Slightly stronger shadow */\n  min-height: 150px; /* Increased from 120px */\n  text-align: center;\n  transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;\n}\n\n.intro-card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);\n}\n\n.card-icon {\n  margin-bottom: 25px; /* Increased from 20px */\n}\n\n.card-icon svg {\n  width: 40px; /* Increased from 30px */\n  height: 40px; /* Increased from 30px */\n  stroke: #1976d2;\n  stroke-width: 2;\n}\n\n.card-text {\n  color: #1976d2;\n  font-size: 18px; /* Increased from 16px */\n  font-weight: 500;\n}\n\n/* Wave container */\n.wave-container {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 250px;\n  z-index: 1;\n  overflow: hidden;\n}\n\n.wave {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n}\n\n.wave-top {\n  bottom: 45px;\n  opacity: 0.7;\n}\n\n.wave-middle {\n  bottom: 25px;\n  opacity: 0.8;\n}\n\n.wave-bottom {\n  bottom: -5px; /* This extends slightly below the viewport to eliminate white space */\n  opacity: 0.9;\n}\n\n/* Responsive adjustments */\n@media (max-width: 1200px) {\n  .intro-content {\n    width: 95%;\n    gap: 40px;\n  }\n  \n  .intro-logo {\n    max-width: 400px;\n  }\n  \n  .intro-card {\n    padding: 45px 20px;\n  }\n}\n\n@media (max-width: 992px) {\n  .intro-content {\n    flex-direction: column;\n    gap: 40px;\n    margin-top: 8vh;\n  }\n  \n  .intro-logo-container {\n    justify-content: center;\n  }\n  \n  .intro-logo {\n    max-width: 350px;\n  }\n  \n  .cards-row {\n    gap: 20px;\n  }\n}\n\n@media (max-width: 600px) {\n  .intro-content {\n    margin-top: 5vh;\n  }\n  \n  .cards-row {\n    flex-direction: column;\n    gap: 15px;\n  }\n  \n  .intro-card {\n    padding: 35px 20px;\n    min-height: 130px;\n  }\n  \n  .card-icon svg {\n    width: 35px;\n    height: 35px;\n  }\n  \n  .card-text {\n    font-size: 16px;\n  }\n}\n\n/* Navigation Bar Styles - Add these to your App.css ------------------------------------------------------------------------*/\n\n/* Tools navigation container */\n.tools-nav {\n  background-color: #EEF0F2;\n  width: 100%;\n  padding: 10px;\n  display: flex;\n  justify-content: space-between;\n}\n\n/* Left, center and right sections of the navbar */\n.nav-left, .nav-right {\n  flex: 1;\n}\n\n.nav-center {\n  flex: 4;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n}\n\n/* Back to Home link styles */\n.back-to-home {\n  position: absolute;\n  left: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-decoration: none;\n  color: #1976d2;\n  font-size: 14px;\n  font-weight: 500;\n  padding: 8px 16px;\n  border-radius: 20px;\n  background-color: white;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n  transition: all 0.2s ease;\n  margin-top: 5px;\n}\n\n.back-to-home:hover {\n  background-color: #f0f5ff;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);\n}\n\n.back-icon {\n  display: inline-flex;\n  vertical-align: middle;\n  margin-right: 6px;\n}\n\n.back-text {\n  display: inline-flex;\n  vertical-align: middle;\n}\n\n/* Main navigation links */\n.main-links {\n  display: flex;\n  background-color: white;\n  border-radius: 25px;\n  padding: 5px;\n  list-style: none;\n  margin: 0;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);\n}\n\n.main-links a {\n  display: block;\n  padding: 8px 20px;\n  color: #506580;\n  text-decoration: none;\n  font-size: 14px;\n  font-weight: 500;\n  border-radius: 20px;\n  transition: all 0.2s ease;\n}\n\n.main-links a:hover {\n  background-color: rgba(0, 0, 0, 0.05);\n}\n\n.main-links a.active {\n  background-color: #DEEBFF;\n  color: #3275c7;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n/* Responsive adjustments */\n@media (max-width: 992px) {\n  .nav-center {\n    flex: 6;\n  }\n  \n  .back-to-home {\n    padding: 6px 12px;\n    font-size: 13px;\n  }\n  \n  .main-links a {\n    padding: 6px 15px;\n  }\n}\n\n@media (max-width: 768px) {\n  .tools-nav {\n    flex-direction: column;\n    padding: 10px;\n  }\n  \n  .nav-center {\n    flex-direction: column;\n    gap: 10px;\n    width: 100%;\n    margin-top: 10px;\n  }\n  \n  .back-to-home {\n    position: static;\n    margin-bottom: 10px;\n    width: 100%;\n    justify-content: center;\n  }\n  \n  .main-links {\n    width: 100%;\n    justify-content: center;\n  }\n}\n\n\n/* Define Custom Metric Dialog Styles ------------------------------------------------------------------------------------------------------------------------------------------------------*/\n/* Custom Metric Dialog Styling */\n.modal-content {\n  border-radius: 3px;\n  overflow: visible;\n}\n\n.modal-title {\n  padding: 16px 20px;\n  font-size: 18px;\n  font-weight: 400;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.modal-content-second {\n  padding: 15px;\n}\n\n/* Tab styling for UserDefinedMetric */\n.metric-tabs {\n  min-height: 40px;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.metric-tab {\n  text-transform: none;\n  font-size: 14px;\n  font-weight: 400;\n  min-height: 40px;\n  padding: 8px 16px;\n  color: #555;\n}\n\n.metric-tab.active {\n  color: #1976d2;\n  font-weight: 500;\n}\n\n.metric-tab-indicator {\n  background-color: #1976d2;\n  height: 2px;\n}\n\n/* Info alert box */\n.metric-info-alert {\n  background-color: #e3f2fd;\n  padding: 12px 15px;\n  border-radius: 4px;\n  margin-bottom: 20px;\n  font-size: 14px;\n  color: #0d47a1;\n}\n\n/* Graph container styling */\n.metric-graph-container {\n  height: 180px;\n  width: 100%;\n  margin-bottom: 15px;\n}\n\n.metric-graph-title {\n  text-align: center;\n  font-size: 14px;\n  font-weight: 500;\n  color: #555;\n  margin-bottom: 10px;\n}\n\n/* Classification slider */\n.classification-slider {\n  margin-top: 10px;\n}\n\n.classification-slider-label {\n  font-size: 14px;\n  font-weight: 500;\n  margin-bottom: 5px;\n}\n\n.slider-values {\n  font-size: 12px;\n  color: #555;\n}\n\n/* Parameters section */\n.parameters-container {\n  border: 1px solid #e0e0e0;\n  border-radius: 4px;\n  padding: 15px;\n  background-color: #f9f9f9;\n  margin-bottom: 15px;\n}\n\n.parameter-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 8px 0;\n  border-bottom: 1px solid #eee;\n}\n\n.parameter-row:last-child {\n  border-bottom: none;\n}\n\n.parameter-name {\n  font-weight: 500;\n  margin-right: 4px;\n}\n\n.parameter-info {\n  margin: 0 8px;\n  color: #666;\n}\n\n/* Buttons */\n.process-data-btn {\n  background-color: #1976d2;\n  color: white;\n  text-transform: none;\n  box-shadow: none;\n  font-size: 14px;\n  height: 36px;\n  border-radius: 4px;\n  border: none;\n  padding: 0 16px;\n  cursor: pointer;\n}\n\n.process-data-btn:hover {\n  background-color: #1565c0;\n}\n\n.reverse-categories-btn {\n  margin-top: 10px;\n  background-color: #1976d2;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  padding: 6px 12px;\n  font-size: 12px;\n  cursor: pointer;\n}\n\n.reverse-categories-btn:hover {\n  background-color: #1565c0;\n}\n\n/* Category bar coloring */\n.category-high {\n  background-color: #e53935;\n}\n\n.category-medium {\n  background-color: #fb8c00;\n}\n\n.category-low {\n  background-color: #43a047;\n}\n\n/* Error message */\n.equation-error {\n  padding: 8px 12px;\n  background-color: #ffebee;\n  border-radius: 4px;\n  color: #c62828;\n  margin-bottom: 12px;\n  font-size: 14px;\n}\n\n/* Input fields */\n.metric-text-field {\n  font-size: 14px;\n  height: 36px;\n}\n\n/* Dialog actions */\n.metric-dialog-actions {\n  padding: 12px 20px;\n  border-top: 1px solid #e0e0e0;\n  display: flex;\n  justify-content: space-between;\n}\n\n\n/* Classification Slider Styling --------------------------------------------------------*/\n/* Fixed position labels below slider */\n.category-label-container {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  position: relative;\n  margin-top: 15px;\n  height: 20px;\n}\n\n.category-label {\n  position: relative;\n  font-size: 13px;\n  color: #333;\n}\n\n.category-label::before {\n  content: '';\n  position: absolute;\n  top: -10px;\n  left: 50%;\n  transform: translateX(-50%);\n  height: 10px;\n  width: 1px;\n  background-color: #999;\n}\n\n/* Hide the colored category sections but keep functionality */\n\n/* Style the slider itself */\n\n.MuiSlider-thumb {\n  height: 16px !important;\n  width: 16px !important;\n  background-color: #fff !important;\n  border: 2px solid #2196f3 !important;\n  margin-top: -6px !important;\n}\n\n.MuiSlider-track {\n  height: 4px !important;\n  background-color: #2196f3 !important;\n}\n\n.MuiSlider-rail {\n  height: 4px !important;\n  background-color: #e0e0e0 !important;\n}\n\n/* Classification Slider Styling */\n.slider-viz-container {\n  position: relative;\n  margin-top: 10px;\n  height: 30px;\n  width: 100%;\n}\n\n.slider-marker {\n  position: absolute;\n  top: 0;\n  width: 1px;\n  height: 10px;\n  background-color: #666;\n}\n\n.slider-label {\n  position: absolute;\n  top: 15px;\n  transform: translateX(-50%);\n  font-size: 13px;\n  color: #333;\n}\n\n.blue-button {\n  margin-top: 10px;\n  background-color: #1976d2;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  padding: 6px 12px;\n  font-size: 13px;\n  cursor: pointer;\n}\n\n/* SLIDER ---------------------------------*/\n\n/* Classification labels */\n.classification-label {\n  position: absolute;\n  top: 0;\n  height: 30px;\n  font-size: 14px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: visible; /* Allow text to overflow */\n  white-space: nowrap; /* Keep text on one line */\n}\n\n/* Style for narrow columns - adjust text display */\n.narrow-column {\n  overflow: visible; /* Make sure text can overflow the column */\n  justify-content: flex-start; /* Align text to left */\n  padding-left: 2px; /* Small padding from the line */\n  z-index: 1; /* Ensure text appears above other elements */\n}\n\n\n.MuiSlider-thumb {\n  background-color: #0d6efd !important;\n  border: 2px solid #0d6efd !important;\n}\n\n.MuiSlider-track {\n  background-color: #0d6efd !important;\n}\n\n/* Button styling */\n.blue-button {\n  margin-top: 15px;\n  background-color: #1976d2;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  padding: 6px 12px;\n  font-size: 13px;\n  cursor: pointer;\n}\n\n/* Dynamic classification container */\n.dynamic-classification-container {\n  position: relative;\n  width: 100%;\n  height: 30px;\n  margin-top: 0px;\n}\n\n/* Container with labels below - increase height */\n.dynamic-classification-container.has-labels-below {\n  height: 20px;\n}\n\n/* Vertical marker lines */\n.marker-line {\n  position: absolute;\n  top: 20%;\n  width: 1px;\n  height: 70%;\n  background-color: #1976d2 ;\n  transform: translateX(-0.5px); /* Center the marker */\n  padding-left: 1px;\n  padding-right: 1px;\n}\n\n/* Container for labels displayed below */\n.labels-below-container {\n  position: relative;\n  width: 100%;\n  height: 20px;\n  margin-top: 5px;\n}\n\n/* Individual label displayed below */\n.label-below {\n  position: absolute;\n  transform: translateX(-50%); /* Center horizontally */\n  font-size: 14px;\n  white-space: nowrap;\n  margin-top: 5px;\n}\n\n/* Slider styling overrides */\n\n.MuiSlider-thumb {\n  background-color: #1976d2 !important;\n  border: 2px solid #1976d2 !important;\n}\n\n.MuiSlider-track {\n  background-color: #1976d2 !important;\n}\n\n/* Button styling */\n.blue-button {\n  margin-top: 15px;\n  background-color: #1976d2;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  padding: 6px 12px;\n  font-size: 13px;\n  cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
